/* --- SCRIPT PER RECUPERO SPAZIO MENU PRINCIPALE - INIZIO --- */
// Patch "asimmetrica" nel tuo custom-scripts.js
(function () {
  if (window.__navPatchApplied) return;

  function patch() {
    if (!window.theme || !theme.inlineNavigationCheck || !theme.enqueueStyleUpdate) return false;

    theme.inlineNavigationCheck = function () {
      if (document.hidden) return;

      const pageHeader = document.querySelector('.pageheader');
      const inlineNavContainer = pageHeader?.querySelector('.logo-area__left');
      const inlineNav = inlineNavContainer?.querySelector('.navigation');
      const logoArea = pageHeader?.querySelector('.logo-area');
      if (!inlineNav || !logoArea || getComputedStyle(inlineNav).display === 'none') return;

      const centered = document.querySelector('.pageheader--layout-inline-menu-center');
      let availableNavWidth = inlineNavContainer.offsetWidth;

      if (centered) {
        const right  = pageHeader.querySelector('.logo-area__right__inner')?.clientWidth || 0;
        const middle = pageHeader.querySelector('.logo-area__middle__inner')?.clientWidth || 0;
        const cs = getComputedStyle(logoArea);
        const inner = logoArea.clientWidth - Math.ceil(parseFloat(cs.paddingLeft)) - Math.ceil(parseFloat(cs.paddingRight));
        const gutter = 8; // regola qui se vuoi più/meno margine di sicurezza
        availableNavWidth = inner - middle - right - gutter;
      }

      const requiredNavWidth = inlineNav.clientWidth;
      if (logoArea.clientWidth <= 0 || availableNavWidth <= 0 || requiredNavWidth <= 0) return;

      theme.enqueueStyleUpdate(() => {
        pageHeader.classList.toggle(
          'pageheader--layout-inline-permitted',
          availableNavWidth >= requiredNavWidth
        );
      });
    };

    let checkFrame = 0;

    function scheduleInlineNavigationCheck() {
      if (document.hidden) return;

      cancelAnimationFrame(checkFrame);
      checkFrame = requestAnimationFrame(function () {
        checkFrame = requestAnimationFrame(theme.inlineNavigationCheck);
      });
    }

    scheduleInlineNavigationCheck();
    window.addEventListener('resize', scheduleInlineNavigationCheck, { passive: true });
    window.addEventListener('load', scheduleInlineNavigationCheck);
    window.addEventListener('pageshow', scheduleInlineNavigationCheck);
    document.addEventListener('shopify:section:load', scheduleInlineNavigationCheck);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleInlineNavigationCheck();
    });

    if (document.fonts?.ready) {
      document.fonts.ready.then(scheduleInlineNavigationCheck);
    }

    window.__navPatchApplied = true;
    return true;
  }

  function wait() { if (!patch()) setTimeout(wait, 50); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wait);
  else wait();
})();
/* --- SCRIPT PER RECIPERO SPAZIO MENU PRINCIPALE - FINE --- */

(function () {
  function fromCodes(codes) {
    return String.fromCharCode.apply(String, codes);
  }

  const deferredNavigationPromotionContent = {
    p1: {
      subheading: fromCodes([80,101,114,115,111,110,97,108,105,122,122,97,32,99,111,110,32,115,116,105,108,101]),
      title: fromCodes([69,116,105,99,104,101,116,116,101,32,112,101,114,32,98,111,116,116,105,103,108,105,101,32,100,105,32,118,105,110,111]),
      text: fromCodes([67,114,101,97,32,101,116,105,99,104,101,116,116,101,32,101,108,101,103,97,110,116,105,32,101,32,117,110,105,99,104,101,32,112,101,114,32,108,101,32,116,117,101,32,98,111,116,116,105,103,108,105,101,32,100,105,32,118,105,110,111,58,32,112,101,114,102,101,116,116,101,32,112,101,114,32,109,97,116,114,105,109,111,110,105,44,32,101,118,101,110,116,105,44,32,99,97,110,116,105,110,101,32,111,32,114,101,103,97,108,105,32,115,112,101,99,105,97,108,105,46,32,83,99,101,103,108,105,32,105,108,32,109,111,100,101,108,108,111,44,32,105,110,115,101,114,105,115,99,105,32,105,108,32,116,117,111,32,116,101,115,116,111,32,101,32,112,101,114,115,111,110,97,108,105,122,122,97,32,111,103,110,105,32,100,101,116,116,97,103,108,105,111,46]),
      buttonLabels: [
        fromCodes([71,117,97,114,100,97,32,105,32,100,101,115,105,103,110]),
        fromCodes([67,114,101,97,32,108,97,32,116,117,97,32,101,116,105,99,104,101,116,116,97])
      ]
    }
  };

  function fillDeferredNavigationPromotionContent(root) {
    root.querySelectorAll("[data-navigation-deferred-promotion]").forEach(function (promo) {
      const content = deferredNavigationPromotionContent[promo.dataset.navigationDeferredPromotion];

      if (!content || promo.dataset.navigationDeferredPromotionLoaded === "true") return;

      const subheading = promo.querySelector(".subheading--over");
      const title = promo.querySelector(".majortitle");
      const text = promo.querySelector(".rte");
      const buttonLabels = promo.querySelectorAll(".button-row__button .btn__text");

      if (subheading) subheading.textContent = content.subheading;
      if (title) title.textContent = content.title;
      if (text) {
        text.textContent = "";
        const paragraph = document.createElement("p");
        paragraph.textContent = content.text;
        text.appendChild(paragraph);
      }

      buttonLabels.forEach(function (label, index) {
        if (content.buttonLabels[index]) {
          label.textContent = content.buttonLabels[index];
        }
      });

      promo.dataset.navigationDeferredPromotionLoaded = "true";
    });
  }

  function hydrateNavigationPromotions(target) {
    const item = target.closest(".navigation__tier-1 > .navigation__item");

    if (!item) return;

    const templates = item.querySelectorAll(
      "template[data-navigation-promotion-template]"
    );

    if (!templates.length) return;

    templates.forEach(function (template) {
      const content = template.content.cloneNode(true);

      fillDeferredNavigationPromotionContent(content);
      template.replaceWith(content);
    });

    if (window.theme && typeof window.theme.manualLazyload === "function") {
      window.theme.manualLazyload(item);
    }
  }

  ["mouseover", "focusin", "touchstart", "click"].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function (event) {
        hydrateNavigationPromotions(event.target);
      },
      true
    );
  });
})();

/* --- SCRIPT PER MENU MOBILE - INIZIO --- */
/* --- Script Definitivo e Completo con Logica "Ponte" --- */

document.addEventListener("DOMContentLoaded", function () {
  // --- PARTE 1: IL "PONTE" ---
  // Applica una classe al BODY quando il menu mobile è realmente visibile.
  const body = document.body;

  function isElementVisible(el) {
    if (!el || !el.isConnected) return false;

    const style = window.getComputedStyle(el);
    const rect = el.getBoundingClientRect();

    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      style.opacity !== "0" &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function isMobileMenuVisible() {
    const toggles = document.querySelectorAll(".mobile-nav-toggle");

    return Array.from(toggles).some(function (toggle) {
      return isElementVisible(toggle);
    });
  }

  function checkMobileView() {
    if (isMobileMenuVisible()) {
      body.classList.add("custom-mobile-view-active");
    } else {
      body.classList.remove("custom-mobile-view-active");
    }
  }

  function scheduleMobileViewCheck() {
    checkMobileView();

    requestAnimationFrame(function () {
      checkMobileView();

      setTimeout(checkMobileView, 100);
      setTimeout(checkMobileView, 300);
    });
  }

  scheduleMobileViewCheck();

  window.addEventListener("resize", scheduleMobileViewCheck);
  window.addEventListener("orientationchange", scheduleMobileViewCheck);

  const pageHeader = document.querySelector("#pageheader");

  if (pageHeader) {
    const observer = new MutationObserver(scheduleMobileViewCheck);

    observer.observe(pageHeader, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ["class", "style"],
    });
  }

  // --- PARTE 2: GESTIONE DEI CLICK SUI PULSANTI DEL MENU ---
  body.addEventListener(
    "click",
    function (event) {
      const mainDrawer = document.querySelector("#MobileNavigationDrawer");
      if (!mainDrawer) return;

      /* --- Logica per aggiungere il testo "Indietro" dinamicamente --- */
      const backButtons = document.querySelectorAll(".mobile-nav-back");
      backButtons.forEach((button) => {
        if (!button.querySelector(".back-button-text")) {
          const textSpan = document.createElement("span");
          textSpan.className = "back-button-text";
          textSpan.textContent = "Indietro";
          button.appendChild(textSpan);
        }
      });

      const openToggle = event.target.closest(".navigation__children-toggle");
      const backButton = event.target.closest(".mobile-nav-back");
      const closeButton = event.target.closest(".mobile-nav-toggle");

      // APRIRE un sottomenu
      if (
        openToggle &&
        !openToggle.classList.contains(
          "navigation__children-toggle--placeholder"
        )
      ) {
        event.preventDefault();
        event.stopPropagation();
        const parentItem = openToggle.closest(
          ".navigation__item--with-children"
        );
        if (parentItem) {
          parentItem.classList.add("is-open");
          mainDrawer.classList.add("submenu-is-active");
          openToggle.setAttribute("aria-expanded", "true");
        }
      }

      // TORNARE INDIETRO di un livello
      if (backButton) {
        event.preventDefault();
        event.stopPropagation();

        // Seleziona TUTTI i sottomenu aperti
        const openItems = mainDrawer.querySelectorAll(
          ".navigation__item--with-children.is-open"
        );

        // Prende l'ULTIMO della lista (quello più in primo piano)
        const lastOpenItem = openItems[openItems.length - 1];

        if (lastOpenItem) {
          lastOpenItem.classList.remove("is-open");

          const originalToggle = lastOpenItem.querySelector(
            ".navigation__children-toggle"
          );
          if (originalToggle) {
            originalToggle.setAttribute("aria-expanded", "false");
          }

          // Controlla se ci sono ANCORA sottomenu aperti dopo averne chiuso uno
          const anyOtherSubmenusOpen = mainDrawer.querySelector(
            ".navigation__item--with-children.is-open"
          );
          if (!anyOtherSubmenusOpen) {
            mainDrawer.classList.remove("submenu-is-active");
          }
        }
      }

      // CHIUDERE tutto il cassetto
      if (closeButton) {
        // La logica per chiudere il cassetto è già gestita dal tema,
        // ma ci assicuriamo di resettare il nostro stato.
        const allOpenItems = mainDrawer.querySelectorAll(
          ".navigation__item--with-children.is-open"
        );
        allOpenItems.forEach((item) => {
          item.classList.remove("is-open");
          const toggle = item.querySelector(".navigation__children-toggle");
          if (toggle) {
            toggle.setAttribute("aria-expanded", "false");
          }
        });
        mainDrawer.classList.remove("submenu-is-active");
      }
    },
    true
  );
});
/* --- SCRIPT PER MENU MOBILE - FINE --- */

/* --- SCRIPT PER PULSANTE CARRELLO - INIZIO --- */
document.addEventListener("DOMContentLoaded", function () {
  const buttonSelector =
    "form.product-purchase-form .quantity-submit-row__submit .button--large";
  const unavailableCombinationText = "Combinazione non acquistabile";

  function setButtonText(btn, text) {
    const textNode = Array.from(btn.childNodes).find((node) => {
      return node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "";
    });

    if (textNode) {
      textNode.textContent = text;
    } else {
      btn.appendChild(document.createTextNode(text));
    }
  }

  function setUnavailableCombinationState(btn, active) {
    btn.classList.toggle("custom-unavailable-combination", active);
    btn.toggleAttribute("data-custom-unavailable-combination", active);

    if (active) {
      btn.disabled = true;
      setButtonText(btn, unavailableCombinationText);
    }
  }

  function normalizeCartButtons(event) {
    const eventVariant = event && event.detail ? event.detail.variant : undefined;
    const buttons = document.querySelectorAll(
      buttonSelector
    );

    buttons.forEach((btn) => {
      const currentText = btn.textContent.replace(/\s+/g, " ").trim();
      const isUnavailableCombination =
        eventVariant === null ||
        currentText === "Non disponibile" ||
        currentText === unavailableCombinationText;

      setUnavailableCombinationState(btn, isUnavailableCombination);

      if (!isUnavailableCombination) {
        setUnavailableCombinationState(btn, false);
      }

      btn.childNodes.forEach((node) => {
        if (
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.trim() === "Non disponibile"
        ) {
          node.textContent = unavailableCombinationText;
        }
      });

      if (!btn.querySelector(".cart-plus-icon")) {
        btn.insertAdjacentHTML(
          "afterbegin",
          '<svg class="cart-plus-icon" viewBox="0 0 576 512" aria-hidden="true" focusable="false"><path class="cart-plus-icon__primary" d="M504 406Q536 421 536 456Q536 479 519.5 495.5Q503 512 480 512Q457 512 440.5 495.5Q424 479 424 456Q424 432 441 416H231Q248 432 248 456Q248 479 231.5 495.5Q215 512 192 512Q169 512 152.5 495.5Q136 479 136 456Q136 424 164 407L94 64H24Q14 64 7 57Q0 50 0 40V24Q0 14 7 7Q14 0 24 0H127Q135 0 141.5 5.5Q148 11 150 19L218 352H487Q496 352 503.5 359Q511 366 511 376Q511 379 510 381ZM304 216Q297 216 292.5 211.5Q288 207 288 200V184Q288 177 292.5 172.5Q297 168 304 168H344V128Q344 121 348.5 116.5Q353 112 360 112H376Q383 112 387.5 116.5Q392 121 392 128V168H432Q439 168 443.5 172.5Q448 177 448 184V200Q448 207 443.5 211.5Q439 216 432 216H392V256Q392 263 387.5 267.5Q383 272 376 272H360Q353 272 348.5 267.5Q344 263 344 256V216Z"></path><path class="cart-plus-icon__secondary" d="M552 64Q555 64 557 65Q576 69 576 88Q576 91 575 93L528 301Q524 320 505 320H212L159 64ZM448 200V184Q448 177 443.5 172.5Q439 168 432 168H392V128Q392 121 387.5 116.5Q383 112 376 112H360Q353 112 348.5 116.5Q344 121 344 128V168H304Q297 168 292.5 172.5Q288 177 288 184V200Q288 207 292.5 211.5Q297 216 304 216H344V256Q344 263 348.5 267.5Q353 272 360 272H376Q383 272 387.5 267.5Q392 263 392 256V216H432Q439 216 443.5 211.5Q448 207 448 200Z"></path></svg>'
        );
      }
    });
  }

  normalizeCartButtons();

  const observerCartButton = new MutationObserver(normalizeCartButtons);

  observerCartButton.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.addEventListener("on:variant:change", function (event) {
    window.setTimeout(function () {
      normalizeCartButtons(event);
    }, 0);
  });
});
/* --- SCRIPT PER PULSANTE CARRELLO - FINE --- */

/* --- PRESERVA NASCONDIMENTO PULSANTE CARRELLO PITCHPRINT - INIZIO --- */
(function () {
  const FORM_SELECTOR = 'form.product-purchase-form.js-product-form-stable';
  const CART_AREA_SELECTOR = FORM_SELECTOR + ' .quantity-submit-row__submit';
  const CART_BUTTON_SELECTOR = CART_AREA_SELECTOR + ' button[type="submit"]';
  const PITCHPRINT_SELECTOR = [
    '.ppc-main-ui',
    '#pp_customize_design_btn',
    '#pp_edit_btn',
    '#pp_upload_btn',
    '#pp_clear_design_btn',
    '#_pitchprint',
    'input[name*="pitchprint"]',
    'iframe[src*="pitchprint.io"]'
  ].join(',');
  const PITCHPRINT_VALUE_SELECTOR = [
    '#_pitchprint',
    'input[name="properties[_pitchprint]"]',
    'input[name*="_pitchprint"]',
    'input[name*="pitchprint"]'
  ].join(',');

  let shouldKeepHidden = false;
  let isApplyingHiddenState = false;
  let observedButton = null;
  let observedArea = null;
  let attributeObserver = null;

  function getCartButton() {
    return document.querySelector(CART_BUTTON_SELECTOR);
  }

  function getCartArea() {
    return document.querySelector(CART_AREA_SELECTOR);
  }

  function hasPitchPrintContext() {
    return !!document.querySelector(PITCHPRINT_SELECTOR);
  }

  function applyPitchPrintButtonPreference() {
    if (!window.ppclient || typeof window.ppclient.setBtnPref !== 'function') {
      return false;
    }

    window.ppclient.setBtnPref();
    return true;
  }

  function hasPitchPrintDesign() {
    const input = document.querySelector(PITCHPRINT_VALUE_SELECTOR);

    return !!(input && String(input.value || '').trim());
  }

  function isHiddenByDisplay(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);

    return (
      el.hidden ||
      el.classList.contains('hidden') ||
      style.display === 'none' ||
      style.visibility === 'hidden'
    );
  }

  function isCartButtonHidden() {
    const button = getCartButton();
    const area = getCartArea();

    return isHiddenByDisplay(button) || isHiddenByDisplay(area);
  }

  function setButtonHidden(button, hidden) {
    if (!button) return;

    isApplyingHiddenState = true;

    if (hidden) {
      button.style.setProperty('display', 'none', 'important');
      button.setAttribute('data-pp-hidden-preserved', 'true');
    } else if (button.getAttribute('data-pp-hidden-preserved') === 'true') {
      button.style.removeProperty('display');
      button.removeAttribute('data-pp-hidden-preserved');
    }

    isApplyingHiddenState = false;
  }

  function applyPreservedState() {
    const button = getCartButton();

    if (hasPitchPrintDesign()) {
      shouldKeepHidden = false;
    }

    if (shouldKeepHidden) {
      setButtonHidden(button, true);
    } else {
      setButtonHidden(button, false);
    }
  }

  function updatePreservedStateFromDom() {
    if (isApplyingHiddenState || !hasPitchPrintContext()) return;

    const button = getCartButton();
    if (!button) return;

    if (hasPitchPrintDesign()) {
      shouldKeepHidden = false;
      return;
    }

    shouldKeepHidden = isCartButtonHidden();
  }

  function observeCurrentCartElements() {
    const button = getCartButton();
    const area = getCartArea();

    if (button === observedButton && area === observedArea) return false;

    observedButton = button;
    observedArea = area;

    if (attributeObserver) {
      attributeObserver.disconnect();
    }

    attributeObserver = new MutationObserver(function () {
      updatePreservedStateFromDom();
      applyPreservedState();
    });

    [button, area].forEach(function (el) {
      if (!el) return;

      attributeObserver.observe(el, {
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
      });
    });

    return true;
  }

  function syncPitchPrintCartVisibility() {
    const observedElementChanged = observeCurrentCartElements();
    applyPitchPrintButtonPreference();

    if (!observedElementChanged) {
      updatePreservedStateFromDom();
    }

    applyPreservedState();
  }

  function init() {
    syncPitchPrintCartVisibility();

    const bodyObserver = new MutationObserver(syncPitchPrintCartVisibility);

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('on:variant:change', function () {
      window.setTimeout(syncPitchPrintCartVisibility, 0);
    });
  }

  if (document.body) {
    init();
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* --- PRESERVA NASCONDIMENTO PULSANTE CARRELLO PITCHPRINT - FINE --- */

/* --- VALIDAZIONE BSS REQUIRED PRIMA DI AJAX ADD TO CART - INIZIO --- */
(function () {
  if (window.__bssRequiredGuardLoaded) return;
  window.__bssRequiredGuardLoaded = true;

  const FORM_SELECTOR = 'form.product-purchase-form.js-product-form-stable';
  const STACK_SELECTOR = [
    '.bss-po-product-page .po-stack',
    '.bss-po-option-set .po-stack',
    '.po-stack[id^="po_stack"]'
  ].join(',');
  const REQUIRED_MARKER_SELECTOR = [
    '[required]',
    '[aria-required="true"]',
    '.po-required',
    '.po-label-required',
    '.required'
  ].join(',');
  const FIELD_SELECTOR = [
    'input',
    'select',
    'textarea',
    '[contenteditable="true"]'
  ].join(',');
  const MESSAGE_CLASS = 'bss-po-required-message';
  const INVALID_CLASS = 'bss-po-required-missing';
  const MESSAGE_TEXT = 'Seleziona questa opzione prima di aggiungere il prodotto al carrello.';
  const SELECTED_VALUE_SELECTOR = [
    '.po-selected-swatch .po-value:not(:empty)',
    '.po-selected-button .po-value:not(:empty)',
    '.po-option__value.is-selected',
    '.po-option__value.selected',
    '.po-dropdown-option.selected',
    '.po-dropdown-thumbnail-option.selected',
    '.po-font_picker-option--dropdown.selected',
    'option[id*="po_dropdown"][selected="true"]'
  ].join(',');
  const EMPTY_VALUE_PATTERN = /^(|--\s*(please select|seleziona|scegli)[^-]*\s*--|please select|seleziona|scegli|null|undefined)$/i;

  function isVisible(el) {
    if (!el || el.hidden) return false;

    let node = el;

    while (node && node.nodeType === Node.ELEMENT_NODE) {
      const style = window.getComputedStyle(node);

      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        Number(style.opacity) === 0
      ) {
        return false;
      }

      node = node.parentElement;
    }

    return !!el.getClientRects().length;
  }

  function isRequiredStack(stack) {
    if (!isVisible(stack)) return false;

    if (stack.querySelector(REQUIRED_MARKER_SELECTOR)) return true;

    const label = stack.querySelector('.po-label-container label, label.po-label, .po-label');
    const labelText = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';

    return labelText.includes('*');
  }

  function getStackFields(stack) {
    return Array.from(stack.querySelectorAll(FIELD_SELECTOR)).filter(function (field) {
      if (field.disabled) return false;
      if (field.tagName === 'INPUT' && field.type === 'hidden') return false;
      if (field.closest('.quantity-control')) return false;
      if (field.classList.contains('quantity-input')) return false;

      return true;
    });
  }

  function hasMeaningfulValue(value) {
    const normalizedValue = String(value || '').replace(/\s+/g, ' ').trim();

    return normalizedValue !== '' && !EMPTY_VALUE_PATTERN.test(normalizedValue);
  }

  function fieldHasValue(field, stack) {
    const tagName = field.tagName.toLowerCase();

    if (tagName === 'select') {
      const options = Array.from(field.options || []);
      const selectedOptions = Array.from(field.selectedOptions || []).concat(
        options.filter(function (option) {
          return option.getAttribute('selected') === 'true';
        })
      );

      return selectedOptions.some(function (option) {
        return hasMeaningfulValue(option.value || option.textContent);
      });
    }

    if (tagName === 'textarea') {
      return hasMeaningfulValue(field.value);
    }

    if (field.matches('[contenteditable="true"]')) {
      return hasMeaningfulValue(field.textContent);
    }

    if (field.type === 'radio') {
      if (!field.name) return field.checked;

      return !!stack.querySelector(
        'input[type="radio"][name="' + CSS.escape(field.name) + '"]:checked'
      );
    }

    if (field.type === 'checkbox') {
      if (!field.name) return field.checked;

      return !!stack.querySelector(
        'input[type="checkbox"][name="' + CSS.escape(field.name) + '"]:checked'
      );
    }

    if (field.type === 'file') {
      return field.files && field.files.length > 0;
    }

    return hasMeaningfulValue(field.value);
  }

  function stackHasValue(stack) {
    const fields = getStackFields(stack);

    if (!fields.length) {
      return Array.from(stack.querySelectorAll(SELECTED_VALUE_SELECTOR)).some(function (selectedValue) {
        return hasMeaningfulValue(
          selectedValue.value ||
          selectedValue.getAttribute('data-value') ||
          selectedValue.getAttribute('value') ||
          selectedValue.textContent
        );
      });
    }

    if (fields.some(function (field) {
      return fieldHasValue(field, stack);
    })) {
      return true;
    }

    return Array.from(stack.querySelectorAll(SELECTED_VALUE_SELECTOR)).some(function (selectedValue) {
      return hasMeaningfulValue(
        selectedValue.value ||
        selectedValue.getAttribute('data-value') ||
        selectedValue.getAttribute('value') ||
        selectedValue.textContent
      );
    });
  }

  function clearStackError(stack) {
    stack.classList.remove(INVALID_CLASS);
    stack.style.removeProperty('outline');
    stack.style.removeProperty('outline-offset');
    stack.querySelectorAll('[aria-invalid="true"]').forEach(function (field) {
      field.removeAttribute('aria-invalid');
    });

    const message = stack.querySelector('.' + MESSAGE_CLASS);

    if (message) {
      message.remove();
    }
  }

  function markStackError(stack) {
    stack.classList.add(INVALID_CLASS);
    stack.style.setProperty('outline', '2px solid #ba2323');
    stack.style.setProperty('outline-offset', '4px');

    getStackFields(stack).forEach(function (field) {
      field.setAttribute('aria-invalid', 'true');
    });

    if (!stack.querySelector('.' + MESSAGE_CLASS)) {
      const message = document.createElement('div');
      message.className = MESSAGE_CLASS;
      message.setAttribute('role', 'alert');
      message.textContent = MESSAGE_TEXT;
      message.style.color = '#ba2323';
      message.style.fontSize = '14px';
      message.style.marginTop = '8px';

      const label = stack.querySelector('.po-label-container') || stack.firstElementChild;

      if (label) {
        label.insertAdjacentElement('afterend', message);
      } else {
        stack.prepend(message);
      }
    }
  }

  function validateBssRequiredOptions() {
    const stacks = Array.from(document.querySelectorAll(STACK_SELECTOR));
    const invalidStacks = [];

    stacks.forEach(function (stack) {
      if (!isRequiredStack(stack)) {
        clearStackError(stack);
        return;
      }

      if (stackHasValue(stack)) {
        clearStackError(stack);
      } else {
        markStackError(stack);
        invalidStacks.push(stack);
      }
    });

    if (invalidStacks.length) {
      invalidStacks[0].scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    return invalidStacks.length === 0;
  }

  function getAddButton(form) {
    return form.querySelector(
      'button[type="submit"][name="add"], button[type="submit"].product-form__submit, button[type="submit"]'
    );
  }

  function showAddToCartError(form) {
    const button = getAddButton(form);

    if (!button) return;

    if (window.BSS_PO && window.BSS_PO.helper && window.BSS_PO.helper.showErrorMsgAddToCart) {
      window.BSS_PO.helper.showErrorMsgAddToCart({
        add_to_cart_btn: button,
        message: MESSAGE_TEXT
      });
      return;
    }

    let message = document.getElementById('bss-atc-error-element');

    if (!message) {
      message = document.createElement('div');
      message.id = 'bss-atc-error-element';
      message.setAttribute('role', 'alert');
      message.innerHTML = '<span></span>';
      button.insertAdjacentElement('beforebegin', message);
    }

    const text = message.querySelector('span') || message;
    text.textContent = MESSAGE_TEXT;
    message.style.display = '';
  }

  function hideAddToCartError() {
    if (window.BSS_PO && window.BSS_PO.helper && window.BSS_PO.helper.hideErrorMsgAddToCart) {
      window.BSS_PO.helper.hideErrorMsgAddToCart();
      return;
    }

    const message = document.getElementById('bss-atc-error-element');

    if (message) {
      message.style.display = 'none';
    }
  }

  function restoreAddButton(form) {
    form.querySelectorAll('button[type="submit"]').forEach(function (button) {
      button.classList.remove('bss-po-button--loading');
      button.classList.remove('btn--in-progress');
      button.removeAttribute('disabled');
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target.closest(FORM_SELECTOR);

      if (!form || !document.querySelector(STACK_SELECTOR)) return;

      if (!validateBssRequiredOptions()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showAddToCartError(form);
        restoreAddButton(form);
      } else {
        hideAddToCartError();
      }
    },
    true
  );

  document.addEventListener('change', function (event) {
    const stack = event.target.closest(STACK_SELECTOR);

    if (stack && isRequiredStack(stack) && stackHasValue(stack)) {
      clearStackError(stack);
      hideAddToCartError();
    }
  });
})();
/* --- VALIDAZIONE BSS REQUIRED PRIMA DI AJAX ADD TO CART - FINE --- */

(function () {
  if (window.__bssForaturaLamieraScatolataLoaded) return;
  window.__bssForaturaLamieraScatolataLoaded = true;

  const STACK_SELECTOR = [
    '.bss-po-product-page .po-stack',
    '.bss-po-option-set .po-stack',
    '.po-stack[id^="po_stack"]'
  ].join(',');
  const HIDDEN_CLASS = 'bss-po-stack--hidden-for-lamiera-scatolata';
  const TARGET_VARIANT_VALUE = 'lamiera scatolata';
  const TARGET_STACK_LABEL = 'foratura';
  const NO_HOLES_VALUE = 'nessun foro';
  let syncTimer = null;

  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase('it-IT');
  }

  function getProductScope(element) {
    return (
      element.closest('.product-form') ||
      element.closest('.quickbuy-content') ||
      element.closest('.section-featured-product') ||
      document
    );
  }

  function getSelectedVariantValues(scope) {
    return Array.from(scope.querySelectorAll('variant-picker .option-selector'))
      .map(function (selector) {
        if (selector.dataset.selectorType === 'dropdown') {
          const selected = selector.querySelector(
            '.custom-select__option[aria-selected="true"]'
          );

          return selected?.dataset.value || selected?.textContent || '';
        }

        return selector.querySelector('input:checked')?.value || '';
      })
      .map(normalize);
  }

  function isLamieraScatolataSelected(scope) {
    return getSelectedVariantValues(scope).includes(TARGET_VARIANT_VALUE);
  }

  function isForaturaStack(stack) {
    const label = stack.querySelector(
      '.po-label-container label, label.po-label, .po-label'
    );
    const labelText = normalize(label?.textContent).replace(/\*/g, '').trim();

    return (
      labelText === TARGET_STACK_LABEL ||
      labelText.startsWith(`${TARGET_STACK_LABEL} (`)
    );
  }

  function getOptionValues(input) {
    return [
      input.value,
      input.dataset.value,
      ...Array.from(input.labels || []).map(function (label) {
        return label.textContent;
      })
    ].map(normalize);
  }

  function setStackHidden(stack, hidden) {
    stack.classList.toggle(HIDDEN_CLASS, hidden);

    if (hidden) {
      stack.dataset.hiddenForLamieraScatolata = 'true';
      stack.setAttribute('aria-hidden', 'true');
    } else {
      delete stack.dataset.hiddenForLamieraScatolata;
      stack.removeAttribute('aria-hidden');
    }
  }

  function selectNoHoles(stack) {
    const noHolesInput = Array.from(
      stack.querySelectorAll('input[type="radio"], input[type="checkbox"]')
    ).find(function (input) {
      return getOptionValues(input).includes(NO_HOLES_VALUE);
    });

    if (!noHolesInput) return false;
    if (noHolesInput.checked) return true;

    // Il click deve avvenire mentre il controllo BSS è ancora visibile:
    // BSS registra così "Nessun foro" prima che il blocco scompaia.
    setStackHidden(stack, false);
    noHolesInput.click();
    window.setTimeout(scheduleSync, 80);

    return false;
  }

  function clearValidationState(stack) {
    stack.classList.remove('bss-po-required-missing');
    stack.style.removeProperty('outline');
    stack.style.removeProperty('outline-offset');
    stack.querySelectorAll('[aria-invalid="true"]').forEach(function (field) {
      field.removeAttribute('aria-invalid');
    });
    stack.querySelector('.bss-po-required-message')?.remove();
  }

  function syncStack(stack) {
    if (!isForaturaStack(stack)) return;

    const shouldHide = isLamieraScatolataSelected(getProductScope(stack));

    if (shouldHide) {
      if (!selectNoHoles(stack)) return;

      clearValidationState(stack);
      setStackHidden(stack, true);
    } else {
      setStackHidden(stack, false);
    }
  }

  function syncAll() {
    document.querySelectorAll(STACK_SELECTOR).forEach(syncStack);
  }

  function scheduleSync() {
    if (syncTimer !== null) return;

    syncTimer = window.setTimeout(function () {
      syncTimer = null;
      syncAll();
    }, 0);
  }

  function comesFromVariantPicker(event) {
    return event.target instanceof Element && event.target.closest('variant-picker');
  }

  function init() {
    syncAll();

    new MutationObserver(scheduleSync).observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener(
      'change',
      function (event) {
        if (comesFromVariantPicker(event)) {
          scheduleSync();
        }
      },
      true
    );
    document.addEventListener('on:variant:change', scheduleSync, true);
    document.addEventListener('shopify:section:load', scheduleSync);
  }

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();

(function () {
  if (window.__productSurchargeAdapterLoaded) return;
  window.__productSurchargeAdapterLoaded = true;

  const SURCHARGE_SELECTOR = '[data-product-surcharge]';
  const EXPECTED_PRICE_PROPERTY = '_surchargeExpectedPrice';
  const TECHNICAL_PROPERTY_NAMES = [
    '_bssPrice',
    '_bssVariants',
    '_bssCustomAttributes'
  ];
  const ADAPTER_VERSION = '1';
  const PRODUCT_ADDON_SELECTOR = '[data-product-addon]';
  const PRODUCT_ADDON_RADIO_SELECTOR = 'input[data-addon-radio]:checked';
  let activeForm = null;
  let activeSubmission = null;

  function toPositiveInteger(value) {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  }

  function getForm(context) {
    if (!context) return null;
    if (context.matches?.('form')) return context;
    return context.closest?.('form') || null;
  }

  function getSurchargeElement(context) {
    const form = getForm(context);
    if (form) {
      return form.querySelector(SURCHARGE_SELECTOR);
    }

    if (activeForm?.isConnected) {
      const activeElement = activeForm.querySelector(SURCHARGE_SELECTOR);
      if (activeElement) return activeElement;
    }

    return document.querySelector(SURCHARGE_SELECTOR);
  }

  function getSurchargeData(context) {
    const element = getSurchargeElement(context);
    if (!element) return null;

    const cents = toPositiveInteger(element.dataset.surchargeCents);
    const amount = Number.parseFloat(element.dataset.surchargeAmount);
    const expectedPrice = toPositiveInteger(element.dataset.surchargeExpectedPrice);

    if (!cents || !Number.isFinite(amount) || amount <= 0) {
      return null;
    }

    return {
      element,
      cents,
      amount,
      expectedPrice
    };
  }

  function setMapValue(map, key, value) {
    if (map?.set instanceof Function) {
      map.set(key, value);
    } else if (map && typeof map === 'object') {
      map[key] = value;
    }
  }

  function setHiddenProperty(form, key, value) {
    const fieldName = `properties[${key}]`;
    let field = Array.from(form.elements).find((element) => element.name === fieldName);

    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = fieldName;
      form.appendChild(field);
    }

    field.value = value;
  }

  function getHiddenProperty(form, key) {
    if (!form) return '';
    const fieldName = `properties[${key}]`;
    const field = Array.from(form.elements).find((element) => element.name === fieldName);
    return field?.value || '';
  }

  function copyHiddenTechnicalProperties(form, chosenOptions, chosenOptionsWithoutPriceAddOns) {
    TECHNICAL_PROPERTY_NAMES.forEach(function (key) {
      const value = getHiddenProperty(form, key);
      if (value === '') return;

      setMapValue(chosenOptions, key, value);
      setMapValue(chosenOptionsWithoutPriceAddOns, key, value);
    });
  }

  function getSelectedProductAddons() {
    return Array.from(document.querySelectorAll(PRODUCT_ADDON_SELECTOR)).reduce(function (addons, addonField) {
      const radio = addonField.querySelector(PRODUCT_ADDON_RADIO_SELECTOR);
      if (!radio) return addons;

      const select = radio.dataset.addonSelectId
        ? document.getElementById(radio.dataset.addonSelectId)
        : addonField.querySelector('[data-addon-select]');
      const label = select?.dataset.addonProductTitle || addonField.dataset.option || 'Accessorio';
      const title = radio.dataset.addonVariantTitle || radio.value;
      const cents = radio.dataset.addonIncluded === 'true'
        ? 0
        : toPositiveInteger(radio.dataset.addonPriceCents);

      addons.push({
        label,
        title,
        amount: Math.round(cents) / 100
      });

      return addons;
    }, []);
  }

  function getSelectedProductAddonExtraAmount() {
    return getSelectedProductAddons().reduce(function (total, addon) {
      return total + addon.amount;
    }, 0);
  }

  function copyProductAddonProperties(chosenOptions, chosenOptionsWithoutPriceAddOns) {
    getSelectedProductAddons().forEach(function (addon) {
      if (!addon.label || !addon.title) return;

      setMapValue(chosenOptions, addon.label, addon.title);
      setMapValue(chosenOptionsWithoutPriceAddOns, addon.label, addon.title);
    });
  }

  function getExpectedPrice(form, surcharge) {
    const container = form.closest('.product-form') || form;
    const priceElement = container.querySelector(
      '[data-surcharge-price][data-surcharge-rendered-cents]'
    );
    const renderedPrice = toPositiveInteger(priceElement?.dataset.surchargeRenderedCents);
    return renderedPrice || surcharge.expectedPrice;
  }

  function prepareSubmission(form) {
    const surcharge = getSurchargeData(form);
    if (!surcharge) return null;

    activeForm = form;

    const expectedPrice = getExpectedPrice(form, surcharge);
    const variantId = toPositiveInteger(form.querySelector('[name="id"]')?.value);
    const quantity = toPositiveInteger(form.querySelector('[name="quantity"]')?.value) || 1;

    activeSubmission = {
      form,
      surcharge,
      expectedPrice,
      variantId,
      quantity
    };
    form.__productSurchargeSubmission = activeSubmission;

    return activeSubmission;
  }

  function rememberActiveForm(event) {
    const form = getForm(event.target);
    if (form?.querySelector(SURCHARGE_SELECTOR)) {
      activeForm = form;
    }
  }

  document.addEventListener('pointerdown', rememberActiveForm, true);
  document.addEventListener('focusin', rememberActiveForm, true);
  document.addEventListener('change', rememberActiveForm, true);
  document.addEventListener(
    'submit',
    function (event) {
      const form = getForm(event.target);
      if (form?.querySelector(SURCHARGE_SELECTOR)) {
        prepareSubmission(form);
      }
    },
    true
  );

  if (typeof window.bssFixSupportCustomPriceIncreament !== 'function') {
    window.bssFixSupportCustomPriceIncreament = function () {};
  }

  const originalCustomExtraPrice = window.bssFixSupportCustomExtraPrice;
  window.bssFixSupportCustomExtraPrice = function (BSS_PO, extraPrice, quantity, chosenOptionsProps) {
    let result = Number.parseFloat(extraPrice) || 0;

    if (typeof originalCustomExtraPrice === 'function') {
      result = Number.parseFloat(
        originalCustomExtraPrice(BSS_PO, result, quantity, chosenOptionsProps)
      ) || 0;
    }

    const surcharge = activeSubmission?.surcharge || getSurchargeData();
    const surchargeAmount = surcharge ? surcharge.amount : 0;
    const productAddonAmount = getSelectedProductAddonExtraAmount();

    return Math.round((result + surchargeAmount + productAddonAmount) * 100) / 100;
  };

  const originalCustomAttributes = window.bssFixSupportCustomAttributeWhenAddToCart;
  window.bssFixSupportCustomAttributeWhenAddToCart = function (
    BSS_PO,
    chosenOptions,
    chosenOptionsWithoutPriceAddOns
  ) {
    let result = {
      chosenOptions,
      chosenOptionsWithoutPriceAddOns
    };

    if (typeof originalCustomAttributes === 'function') {
      result = originalCustomAttributes(
        BSS_PO,
        chosenOptions,
        chosenOptionsWithoutPriceAddOns
      ) || result;
    }

    const submission = activeSubmission || (activeForm ? prepareSubmission(activeForm) : null);
    const form =
      submission?.form ||
      activeForm ||
      getForm(document.activeElement) ||
      document.querySelector('form.product-purchase-form.js-product-form-stable');

    copyHiddenTechnicalProperties(
      form,
      result.chosenOptions,
      result.chosenOptionsWithoutPriceAddOns
    );
    copyProductAddonProperties(result.chosenOptions, result.chosenOptionsWithoutPriceAddOns);

    const surcharge = submission?.surcharge || getSurchargeData();
    if (!surcharge) return result;

    return result;
  };

  function getAddedItems(response) {
    const items = [];
    const addItem = function (item) {
      if (item && typeof item === 'object' && item.key) {
        items.push(item);
      }
    };

    addItem(response);
    addItem(response?.item);

    if (Array.isArray(response?.items)) {
      response.items.forEach(addItem);
    }

    return items;
  }

  async function fetchCart() {
    const response = await fetch(`${window.theme.routes.cart_url}.js`, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Cart verification failed');
    }

    return response.json();
  }

  function getLineExpectedPrice(line, submission) {
    const propertyValue = line.properties?.[EXPECTED_PRICE_PROPERTY];
    const propertyPrice = toPositiveInteger(propertyValue);

    if (propertyPrice) return propertyPrice;
    if (submission && Number(line.variant_id || line.id) === submission.variantId) {
      return submission.expectedPrice;
    }

    return 0;
  }

  function getCandidateLines(cart, response, submission) {
    const addedItems = getAddedItems(response);
    const addedKeys = new Set(addedItems.map((item) => item.key));

    if (addedKeys.size) {
      return cart.items.filter((line) => addedKeys.has(line.key));
    }

    return cart.items.filter(function (line) {
      if (Number(line.variant_id || line.id) !== submission.variantId) return false;

      return Boolean(
        line.properties?.[EXPECTED_PRICE_PROPERTY] ||
        line.properties?._bssPrice
      );
    });
  }

  async function verifyAddedSurcharge(response, submission) {
    const cart = await fetchCart();
    const lines = getCandidateLines(cart, response, submission);

    if (!lines.length) {
      return {
        valid: false,
        cart,
        lines: []
      };
    }

    const invalidLines = lines.filter(function (line) {
      const expectedPrice = getLineExpectedPrice(line, submission);
      const transformedPrice = Number(line.original_price ?? line.price);
      return !expectedPrice || !Number.isFinite(transformedPrice) || transformedPrice < expectedPrice;
    });

    return {
      valid: invalidLines.length === 0,
      cart,
      lines
    };
  }

  async function changeLineQuantity(key, quantity) {
    const response = await fetch(window.theme.routes.cart_change_url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity
      })
    });

    if (!response.ok) {
      throw new Error('Cart cleanup failed');
    }

    return response.json();
  }

  async function removeLines(lines, quantityToRemove, removeCompletely) {
    const uniqueLines = Array.from(
      new Map(lines.filter((line) => line?.key).map((line) => [line.key, line])).values()
    );

    for (const line of uniqueLines) {
      const nextQuantity = removeCompletely
        ? 0
        : Math.max(0, toPositiveInteger(line.quantity) - quantityToRemove);
      await changeLineQuantity(line.key, nextQuantity);
    }
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(
      new CustomEvent('theme:cartchanged', {
        bubbles: true,
        cancelable: false
      })
    );
  }

  function restoreForm(form) {
    form?.querySelectorAll('button[type="submit"]').forEach(function (button) {
      button.classList.remove('btn--in-progress');
      button.removeAttribute('disabled');
    });
  }

  function getErrorMessage() {
    return (
      window.theme?.strings?.products_product_surcharge_error ||
      'The surcharge could not be applied correctly. Refresh the page and try again.'
    );
  }

  function reportFailure(reason, submission, lines) {
    const detail = {
      reason,
      adapterVersion: ADAPTER_VERSION,
      productId: submission?.surcharge?.element?.dataset.productId || null,
      variantId: submission?.variantId || null,
      expectedPrice: submission?.expectedPrice || null,
      actualPrices: Array.isArray(lines)
        ? lines.map((line) => Number(line.original_price ?? line.price) || null)
        : [],
      page: `${window.location.origin}${window.location.pathname}`
    };

    console.error('[ProductSurchargeAdapter]', detail);
    document.dispatchEvent(
      new CustomEvent('product-surcharge:error', {
        detail
      })
    );

    if (window.ProductSurchargeMonitor?.report instanceof Function) {
      Promise.resolve(window.ProductSurchargeMonitor.report(detail)).catch(function () {});
    }
  }

  function getAlertStorageKey(detail) {
    return [
      'productSurchargeAlert',
      detail.reason,
      detail.productId || 'cart',
      detail.variantId || 'unknown'
    ].join(':');
  }

  function wasAlertSentRecently(detail) {
    try {
      const sentAt = Number(window.localStorage.getItem(getAlertStorageKey(detail)));
      return Number.isFinite(sentAt) && Date.now() - sentAt < 21600000;
    } catch (error) {
      return false;
    }
  }

  function rememberAlert(detail) {
    try {
      window.localStorage.setItem(getAlertStorageKey(detail), String(Date.now()));
    } catch (error) {
      return;
    }
  }

  function getAlertBody(detail) {
    return [
      'ALLARME SOVRAPPREZZO',
      `Motivo: ${detail.reason}`,
      `Versione adattatore: ${detail.adapterVersion}`,
      `Prodotto Shopify: ${detail.productId || 'non disponibile'}`,
      `Variante Shopify: ${detail.variantId || 'non disponibile'}`,
      `Prezzo minimo atteso: ${detail.expectedPrice || 'non disponibile'} centesimi`,
      `Prezzi rilevati: ${detail.actualPrices.length ? detail.actualPrices.join(', ') : 'non disponibili'} centesimi`,
      `Pagina: ${detail.page}`,
      `Data: ${new Date().toISOString()}`
    ].join('\n');
  }

  async function sendShopifyContactAlert(detail) {
    if (wasAlertSentRecently(detail)) return;

    const form = document.getElementById('product-surcharge-alert-form');
    const bodyField = form?.querySelector('[name="contact[body]"]');
    if (!form || !bodyField) {
      throw new Error('Shopify contact alert form unavailable');
    }

    bodyField.value = getAlertBody(detail);

    const response = await fetch(form.action, {
      method: 'POST',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new FormData(form)
    });

    if (!response.ok) {
      throw new Error('Shopify contact alert failed');
    }

    rememberAlert(detail);
  }

  function showVerificationError(anchor) {
    const message = getErrorMessage();
    const target = anchor?.matches?.('button, a')
      ? anchor
      : anchor?.querySelector?.('button[type="submit"], a');

    if (
      target &&
      window.theme?.showQuickPopup instanceof Function &&
      window.jQuery instanceof Function
    ) {
      window.theme.showQuickPopup(message, window.jQuery(target), 'error');
      return;
    }

    window.alert(message);
  }

  function clearSubmission(form) {
    if (form) {
      delete form.__productSurchargeSubmission;
    }
    activeSubmission = null;
  }

  function installAddedToCartGuard() {
    const originalAddedToCartHandler = window.theme?.addedToCartHandler;
    if (
      typeof originalAddedToCartHandler !== 'function' ||
      originalAddedToCartHandler.__productSurchargeGuard
    ) {
      return;
    }

    const guardedHandler = function (...args) {
      const form = this;
      const submission = form.__productSurchargeSubmission;

      if (!submission) {
        return originalAddedToCartHandler.apply(form, args);
      }

      verifyAddedSurcharge(args[0], submission)
        .then(async function (verification) {
          if (verification.valid) {
            clearSubmission(form);
            originalAddedToCartHandler.apply(form, args);
            return;
          }

          reportFailure('price_transform_mismatch', submission, verification.lines);
          await removeLines(verification.lines, submission.quantity, false);
          clearSubmission(form);
          restoreForm(form);
          refreshCart();
          showVerificationError(form);
        })
        .catch(function () {
          reportFailure('add_verification_unavailable', submission, []);
          clearSubmission(form);
          restoreForm(form);
          refreshCart();
          showVerificationError(form);
        });
    };

    guardedHandler.__productSurchargeGuard = true;
    window.theme.addedToCartHandler = guardedHandler;
  }

  async function verifyCartSurcharges() {
    const cart = await fetchCart();
    const surchargeLines = cart.items.filter(function (line) {
      return toPositiveInteger(line.properties?.[EXPECTED_PRICE_PROPERTY]) > 0;
    });
    const invalidLines = surchargeLines.filter(function (line) {
      const expectedPrice = toPositiveInteger(line.properties?.[EXPECTED_PRICE_PROPERTY]);
      const transformedPrice = Number(line.original_price ?? line.price);
      return !Number.isFinite(transformedPrice) || transformedPrice < expectedPrice;
    });

    return {
      valid: invalidLines.length === 0,
      invalidLines
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      const checkoutControl = event.target.closest?.(
        'button[name="checkout"], a[href*="/checkout"]'
      );

      if (!checkoutControl || checkoutControl.dataset.surchargeGuardBypass === 'true') {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      checkoutControl.setAttribute('aria-busy', 'true');

      verifyCartSurcharges()
        .then(async function (verification) {
          if (!verification.valid) {
            reportFailure('checkout_price_mismatch', null, verification.invalidLines);
            await removeLines(verification.invalidLines, 0, true);
            checkoutControl.removeAttribute('aria-busy');
            refreshCart();
            showVerificationError(checkoutControl);
            return;
          }

          checkoutControl.dataset.surchargeGuardBypass = 'true';
          checkoutControl.removeAttribute('aria-busy');

          if (checkoutControl.matches('a')) {
            window.location.assign(checkoutControl.href);
          } else if (checkoutControl.form?.requestSubmit instanceof Function) {
            checkoutControl.form.requestSubmit(checkoutControl);
          } else {
            checkoutControl.click();
          }
        })
        .catch(function () {
          reportFailure('checkout_verification_unavailable', null, []);
          checkoutControl.removeAttribute('aria-busy');
          showVerificationError(checkoutControl);
        });
    },
    true
  );

  installAddedToCartGuard();

  window.ProductSurchargeMonitor = {
    report: sendShopifyContactAlert
  };

  window.ProductSurchargeAdapter = {
    version: ADAPTER_VERSION,
    verifyCart: verifyCartSurcharges
  };
})();

/* --- SINCRONIZZA PAYLOAD BSS PRIMA DEL SUBMIT TEMA - INIZIO --- */
(function () {
  if (window.__bssSubmitPayloadSyncLoaded) return;
  window.__bssSubmitPayloadSyncLoaded = true;

  const FORM_SELECTOR = [
    'form.product-purchase-form.js-product-form-stable',
    'form.shopify-product-form[action*="/cart/add"]',
    '.shopify-app-block form[action*="/cart/add"]'
  ].join(',');
  const BSS_PRICE_PROPERTY = '_bssPrice';
  const BSS_VARIANTS_PROPERTY = '_bssVariants';
  const BSS_CUSTOM_ATTRIBUTES_PROPERTY = '_bssCustomAttributes';

  function getProductForm(context) {
    if (context?.matches?.(FORM_SELECTOR)) return context;
    return context?.closest?.(FORM_SELECTOR) || document.querySelector(FORM_SELECTOR);
  }

  function getSubmitControl(context) {
    const submitControl = context?.closest?.('button[type="submit"], input[type="submit"], [type="submit"]');
    if (!submitControl) return null;

    const form = getProductForm(submitControl);
    return form?.contains(submitControl) ? submitControl : null;
  }

  function getHiddenPropertyField(form, key) {
    if (!form) return null;
    const fieldName = `properties[${key}]`;
    return Array.from(form.elements).find((element) => element.name === fieldName) || null;
  }

  function setHiddenProperty(form, key, value) {
    const fieldName = `properties[${key}]`;
    let field = getHiddenPropertyField(form, key);

    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = fieldName;
      form.appendChild(field);
    }

    field.value = value;
  }

  function getExistingBssExtra(form) {
    const field = getHiddenPropertyField(form, BSS_PRICE_PROPERTY);
    if (!field?.value) return 0;

    try {
      const payload = JSON.parse(field.value);
      const extra = Number.parseFloat(payload?.extra);
      const syncedExtra = Number.parseFloat(field.dataset.bssSelectedExtra || '0');
      const baseExtra = Number.isFinite(extra) ? extra - (Number.isFinite(syncedExtra) ? syncedExtra : 0) : 0;
      return Math.max(0, baseExtra);
    } catch (error) {
      return 0;
    }
  }

  function getSelectedBssState() {
    return window.BSS_PO?.currentSelectedOptions || null;
  }

  function getSelectedBssExtra() {
    const state = getSelectedBssState();
    const extra = Number.parseFloat(state?.totalPriceAddOn);
    return Number.isFinite(extra) && extra > 0 ? extra : 0;
  }

  function getBssCustomAttributesFromApi() {
    const getter = window.BSS_PO?.po?.getOptionsSelected;
    if (!(getter instanceof Function)) return null;

    try {
      const selected = getter.call(window.BSS_PO.po);
      const item = Array.isArray(selected) ? selected[0] : null;
      return Array.isArray(item?.customAttributes) ? item.customAttributes : null;
    } catch (error) {
      return null;
    }
  }

  function getBssCustomAttributesFromState() {
    const state = getSelectedBssState();
    if (!Array.isArray(state?.allValues)) return [];

    return state.allValues
      .filter(function (item) {
        return item?.label && item.value != null && String(item.value).trim() !== '';
      })
      .map(function (item) {
        return {
          key: String(item.label),
          value: String(item.value)
        };
      });
  }

  function getBssCustomAttributes() {
    return getBssCustomAttributesFromApi() || getBssCustomAttributesFromState();
  }

  function syncBssPayload(form) {
    if (!form || !window.BSS_PO) return;

    const attributes = getBssCustomAttributes();
    const selectedExtra = getSelectedBssExtra();
    const existingExtra = getExistingBssExtra(form);
    const totalExtra = Math.round((existingExtra + selectedExtra) * 100) / 100;

    attributes.forEach(function (attribute) {
      setHiddenProperty(form, attribute.key, attribute.value);
    });

    setHiddenProperty(form, BSS_CUSTOM_ATTRIBUTES_PROPERTY, '{}');

    if (totalExtra > 0) {
      setHiddenProperty(form, BSS_PRICE_PROPERTY, JSON.stringify({ extra: totalExtra }));
      getHiddenPropertyField(form, BSS_PRICE_PROPERTY).dataset.bssSelectedExtra = String(selectedExtra);
      setHiddenProperty(form, BSS_VARIANTS_PROPERTY, '{}');
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const submitButton = getSubmitControl(event.target);
      if (!submitButton) return;

      syncBssPayload(getProductForm(submitButton));
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      syncBssPayload(getProductForm(event.target));
    },
    true
  );
})();
/* --- SINCRONIZZA PAYLOAD BSS PRIMA DEL SUBMIT TEMA - FINE --- */

/* --- SINCRONIZZA SELETTORE PRODOTTI ACCESSORI - INIZIO --- */
(function () {
  if (window.__productAddonSelectorSyncLoaded) return;
  window.__productAddonSelectorSyncLoaded = true;

  const MAIN_FORM_SELECTOR = 'form.product-purchase-form.js-product-form-stable';
  const FORM_SELECTOR = [
    MAIN_FORM_SELECTOR,
    'form.shopify-product-form[action*="/cart/add"]',
    '.shopify-app-block form[action*="/cart/add"]'
  ].join(',');
  const ADDON_SELECTOR = '[data-product-addon]';
  const ADDON_RADIO_SELECTOR = 'input[data-addon-radio]';
  const ADDON_SELECT_SELECTOR = '[data-addon-select]';
  const ADDON_LABEL_SELECTOR = '.js-addon-value';
  const BSS_PRICE_PROPERTY = '_bssPrice';
  const BSS_VARIANTS_PROPERTY = '_bssVariants';
  const BSS_CUSTOM_ATTRIBUTES_PROPERTY = '_bssCustomAttributes';

  function getMainProductForm() {
    return document.querySelector(MAIN_FORM_SELECTOR);
  }

  function getProductForms() {
    return Array.from(document.querySelectorAll(FORM_SELECTOR));
  }

  function getHiddenPropertyField(form, key) {
    if (!form) return null;
    const fieldName = `properties[${key}]`;
    return Array.from(form.elements).find((element) => element.name === fieldName) || null;
  }

  function setHiddenProperty(form, key, value) {
    if (!form || !key) return null;

    const fieldName = `properties[${key}]`;
    let field = getHiddenPropertyField(form, key);

    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = fieldName;
      form.appendChild(field);
    }

    field.value = value;
    return field;
  }

  function getHiddenPropertyObject(form, key) {
    const field = getHiddenPropertyField(form, key);
    if (!field?.value) return {};

    try {
      const parsed = JSON.parse(field.value);
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function mergeHiddenPropertyObject(form, key, values) {
    const merged = {
      ...getHiddenPropertyObject(form, key),
      ...values
    };

    return Object.keys(merged).length
      ? setHiddenProperty(form, key, JSON.stringify(merged))
      : null;
  }

  function getAddonField(context) {
    return context?.closest?.(ADDON_SELECTOR) || null;
  }

  function getSelectedRadio(addonField) {
    return addonField?.querySelector(ADDON_RADIO_SELECTOR + ':checked') || null;
  }

  function getAddonExtraCents(radio) {
    if (!radio || radio.dataset.addonIncluded === 'true') return 0;

    const cents = Number.parseInt(radio.dataset.addonPriceCents || '0', 10);
    return Number.isFinite(cents) && cents > 0 ? cents : 0;
  }

  function getAddonExtraAmount(radio) {
    return Math.round(getAddonExtraCents(radio)) / 100;
  }

  function getExistingBssExtra(form) {
    const field = getHiddenPropertyField(form, BSS_PRICE_PROPERTY);
    if (!field?.value) return null;

    try {
      const payload = JSON.parse(field.value);
      const extra = Number.parseFloat(payload?.extra);
      const syncedAddonExtra = Number.parseFloat(field.dataset.productAddonSelectedExtra || '0');
      const baseExtra = Number.isFinite(extra)
        ? extra - (Number.isFinite(syncedAddonExtra) ? syncedAddonExtra : 0)
        : 0;
      return Math.max(0, baseExtra);
    } catch (error) {
      return null;
    }
  }

  function syncAddonField(addonField, explicitRadio, options = {}) {
    if (!addonField) return;

    const radio = explicitRadio || getSelectedRadio(addonField);
    if (!radio) return;

    const select = radio.dataset.addonSelectId
      ? document.getElementById(radio.dataset.addonSelectId)
      : addonField.querySelector(ADDON_SELECT_SELECTOR);
    const valueLabel = addonField.querySelector(ADDON_LABEL_SELECTOR);
    const addonTitle = radio.dataset.addonVariantTitle || radio.value;
    const addonExtra = getAddonExtraAmount(radio);
    const mainForm = getMainProductForm();
    const fallbackExistingExtra = getExistingBssExtra(mainForm) || 0;

    if (select && select.value !== radio.value) {
      select.value = radio.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (valueLabel) {
      valueLabel.textContent = addonTitle;
    }

    addonField.dataset.selectedAddonVariantId = radio.value;
    addonField.dataset.selectedAddonVariantTitle = addonTitle;
    addonField.dataset.selectedAddonExtraCents = String(getAddonExtraCents(radio));

    getProductForms().forEach(function (form) {
      const selectLabel = select?.dataset.addonProductTitle || addonField.dataset.option || 'Accessorio';
      setHiddenProperty(form, selectLabel, addonTitle);
      mergeHiddenPropertyObject(form, BSS_CUSTOM_ATTRIBUTES_PROPERTY, {
        [selectLabel]: addonTitle
      });

      const existingExtra = getExistingBssExtra(form) ?? fallbackExistingExtra;
      const totalExtra = Math.round((existingExtra + addonExtra) * 100) / 100;

      if (totalExtra > 0) {
        const bssPriceField = setHiddenProperty(form, BSS_PRICE_PROPERTY, JSON.stringify({ extra: totalExtra }));
        if (bssPriceField) {
          bssPriceField.dataset.productAddonSelectedExtra = String(addonExtra);
        }
        setHiddenProperty(form, BSS_VARIANTS_PROPERTY, '{}');
      }
    });

    if (!options.silent) {
      addonField.dispatchEvent(
        new CustomEvent('product-addon:change', {
          bubbles: true,
          detail: {
            variantId: radio.value,
            title: addonTitle,
            extraCents: getAddonExtraCents(radio)
          }
        })
      );
    }
  }

  function syncAllAddons(options = {}) {
    document.querySelectorAll(ADDON_SELECTOR).forEach(function (addonField) {
      syncAddonField(addonField, null, options);
    });
  }

  document.addEventListener(
    'change',
    function (event) {
      const radio = event.target?.matches?.(ADDON_RADIO_SELECTOR) ? event.target : null;
      if (!radio) return;

      syncAddonField(getAddonField(radio), radio);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllAddons, { once: true });
  } else {
    syncAllAddons();
  }

  window.setTimeout(syncAllAddons, 800);

  window.ProductAddonSelectorSync = {
    sync: function () {
      syncAllAddons({ silent: true });
    }
  };
})();
/* --- SINCRONIZZA SELETTORE PRODOTTI ACCESSORI - FINE --- */

/* --- SINCRONIZZA PREZZO VISIBILE BSS - INIZIO --- */
(function () {
  if (window.__bssDisplayPriceSyncLoaded) return;
  window.__bssDisplayPriceSyncLoaded = true;

  const FORM_SELECTOR = [
    'form.product-purchase-form.js-product-form-stable',
    'form.shopify-product-form[action*="/cart/add"]',
    '.shopify-app-block form[action*="/cart/add"]'
  ].join(',');
  const EXPECTED_PRICE_PROPERTY = '_surchargeExpectedPrice';
  const PRICE_SELECTOR = '[data-surcharge-price], .price-container .current-price.theme-money';
  const BSS_OPTION_SELECTOR = '.bss-po-product-page, .bss-po-option-set, .po-stack[id^="po_stack"]';
  let scheduled = null;
  let delayedScheduled = null;
  let observedPriceElement = null;
  let priceAttributeObserver = null;

  function toPositiveInteger(value) {
    const number = Number.parseInt(value, 10);
    return Number.isFinite(number) && number > 0 ? number : 0;
  }

  function parseMoneyCents(text) {
    const normalized = String(text || '')
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');
    const amount = Number.parseFloat(normalized);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }

  function formatMoney(cents) {
    const amount = Math.round(Number(cents) || 0) / 100;
    const formatted = amount.toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    const format = window.theme?.money_format || '€{{amount_with_comma_separator}}';

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount\s*\}\}/g, amount.toFixed(2));
  }

  function getPriceElement() {
    return document.querySelector(PRICE_SELECTOR);
  }

  function getBasePriceCents(priceElement) {
    if (!priceElement) return 0;

    const renderedCents = toPositiveInteger(priceElement.dataset.surchargeRenderedCents);
    if (renderedCents) {
      const source = String(renderedCents);

      if (priceElement.dataset.bssDisplayBaseSourceCents !== source) {
        priceElement.dataset.bssDisplayBaseSourceCents = source;
        priceElement.dataset.bssDisplayBaseCents = source;
      }

      return toPositiveInteger(priceElement.dataset.bssDisplayBaseCents);
    }

    if (!priceElement.dataset.bssDisplayBaseCents) {
      const parsedCents = parseMoneyCents(priceElement.textContent);
      if (parsedCents) {
        priceElement.dataset.bssDisplayBaseCents = String(parsedCents);
      }
    }

    return toPositiveInteger(priceElement.dataset.bssDisplayBaseCents);
  }

  function getSelectedBssExtraCents() {
    const extra = Number.parseFloat(window.BSS_PO?.currentSelectedOptions?.totalPriceAddOn);
    return Number.isFinite(extra) && extra > 0 ? Math.round(extra * 100) : 0;
  }

  function getSelectedProductAddonExtraCents() {
    return Array.from(document.querySelectorAll('[data-product-addon] input[data-addon-radio]:checked')).reduce(
      function (total, radio) {
        if (radio.dataset.addonIncluded === 'true') return total;

        const cents = Number.parseInt(radio.dataset.addonPriceCents || '0', 10);
        return total + (Number.isFinite(cents) && cents > 0 ? cents : 0);
      },
      0
    );
  }

  function updateExpectedPriceField(cents) {
    const fieldName = `properties[${EXPECTED_PRICE_PROPERTY}]`;

    document.querySelectorAll(FORM_SELECTOR).forEach(function (form) {
      const field = Array.from(form.elements).find((element) => element.name === fieldName);
      if (field) {
        field.value = String(Math.round(cents));
      }
    });
  }

  function syncVisiblePrice() {
    const priceElement = getPriceElement();
    if (!priceElement) return;

    const baseCents = getBasePriceCents(priceElement);
    if (!baseCents) return;

    const finalCents = baseCents + getSelectedBssExtraCents() + getSelectedProductAddonExtraCents();
    const formatted = formatMoney(finalCents);

    if (priceElement.textContent.trim() !== formatted) {
      priceElement.textContent = formatted;
    }

    priceElement.dataset.bssDisplayPriceCents = String(finalCents);
    updateExpectedPriceField(finalCents);
  }

  function observePriceElement() {
    const priceElement = getPriceElement();
    if (!priceElement || priceElement === observedPriceElement) return;

    if (priceAttributeObserver) {
      priceAttributeObserver.disconnect();
    }

    observedPriceElement = priceElement;
    priceAttributeObserver = new MutationObserver(scheduleSync);
    priceAttributeObserver.observe(priceElement, {
      attributes: true,
      attributeFilter: ['data-surcharge-rendered-cents']
    });
  }

  function scheduleSync() {
    if (scheduled) window.clearTimeout(scheduled);
    if (delayedScheduled) window.clearTimeout(delayedScheduled);

    observePriceElement();
    window.requestAnimationFrame(syncVisiblePrice);
    scheduled = window.setTimeout(function () {
      scheduled = null;
      syncVisiblePrice();
    }, 150);
    delayedScheduled = window.setTimeout(function () {
      delayedScheduled = null;
      syncVisiblePrice();
    }, 600);
  }

  function isBssOptionEvent(event) {
    return Boolean(event.target?.closest?.(BSS_OPTION_SELECTOR));
  }

  ['click', 'change', 'input'].forEach(function (eventName) {
    document.addEventListener(
      eventName,
      function (event) {
        if (isBssOptionEvent(event)) scheduleSync();
      },
      true
    );
  });

  document.addEventListener('BSSchangeProductPrice', scheduleSync, true);
  document.addEventListener('product-addon:change', scheduleSync, true);

  let attempts = 0;
  const bootstrap = window.setInterval(function () {
    attempts += 1;
    observePriceElement();
    syncVisiblePrice();

    if (observedPriceElement || attempts > 20) {
      window.clearInterval(bootstrap);
    }
  }, 250);
})();
/* --- SINCRONIZZA PREZZO VISIBILE BSS - FINE --- */

/* --- SCRIPT PER CALCOLO COSTI - INIZIO --- 

// ✅ Utility per leggere numero da input BSS PO
function getBssNumber(id) {
  const input = document.getElementById(id);
  if (!input) return null;
  const raw = input.value || input.getAttribute("value");
  const parsed = parseFloat(raw?.replace(",", "."));
  return isNaN(parsed) ? null : parsed;
}

// ✅ Funzione robusta per parsing JSON del database
function parseMaterialiDb() {
  try {
    const raw = document
      .querySelector("[data-materiali-db]")
      ?.textContent?.trim();
    if (!raw) {
      console.warn("⚠️ JSON database materiali vuoto o mancante");
      return null;
    }
    return JSON.parse(raw);
  } catch (e) {
    console.error("❌ Errore nel parse del JSON database:", e);
    return null;
  }
}

// ✅ Calcolo del prezzo personalizzato
function calcolaPrezzoPersonalizzato({
  larghezza_mm,
  altezza_mm,
  materiale,
  spessore,
  prezzoBase,
}) {
  try {
    const db = parseMaterialiDb();
    if (!db) return null;

    // Adatta il formato da { alluminio: {.}, plexiglas: {.} } → [{ materiale, ... }]
    const materiali = Object.entries(db).map(([nome, dati]) => ({
      materiale: nome.toLowerCase(),
      ...dati,
    }));

    const materialeTrovato = materiali.find(
      (item) =>
        item.materiale === materiale.toLowerCase() &&
        parseFloat(item.spessore) === parseFloat(spessore)
    );

    if (!materialeTrovato) {
      console.warn("⚠️ Materiale o spessore non trovati nel database.");
      return null;
    }

    const area = larghezza_mm * altezza_mm;
    const perimetro = 2 * (larghezza_mm + altezza_mm);

    const coeffMateriale =
      materialeTrovato.costo_lastra /
      (materialeTrovato.larghezza_lastra * materialeTrovato.altezza_lastra);
    const coeffTaglio = materialeTrovato.coeff_taglio_mm;
    const coeffStampa = materialeTrovato.coeff_stampa_mm2;

    const costoMateriale = area * coeffMateriale;
    const costoTaglio = Math.max(perimetro * spessore * coeffTaglio, 2);
    const costoStampa = area * coeffStampa;

    const prezzoCalcolato = costoMateriale + costoTaglio + costoStampa;
    const prezzoFinale = Math.max(prezzoCalcolato, prezzoBase);

    console.groupCollapsed("🧮 Dettaglio calcolo prezzo personalizzato");
    console.log("Materiale:", materiale);
    console.log("Spessore:", spessore);
    console.log("Area (mm²):", area);
    console.log("Perimetro (mm):", perimetro);
    console.log("Costo materiale:", costoMateriale.toFixed(2), "€");
    console.log("Costo taglio:", costoTaglio.toFixed(2), "€");
    console.log("Costo stampa:", costoStampa.toFixed(2), "€");
    console.log("Totale (confrontato con base):", prezzoFinale.toFixed(2), "€");
    console.groupEnd();

    if (window.BSS_PO?.update_price instanceof Function) {
      const prezzoFinto = Math.round(prezzoFinale); // in euro
      console.log("📤 BSS_PO.update_price inviata:", prezzoFinto);
      BSS_PO.update_price({ base_price: prezzoFinto });
    }

    // 🏷️ Aggiunge anche come line item property (solo visiva nel carrello)
    const propertyInput = ensureLineItemPropertyInput();
    if (propertyInput) {
      propertyInput.value = `${prezzoFinale.toFixed(2)} €`;
    }

    return parseFloat(prezzoFinale.toFixed(2));
  } catch (e) {
    console.error("❌ Errore nel calcolo prezzo:", e);
    return null;
  }
}

function ensureLineItemPropertyInput() {
  const form = document.querySelector('form[action^="/cart"]');
  if (!form) return null;

  let input = form.querySelector('input[name="properties[prezzo_calcolato]"]');
  if (!input) {
    input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[prezzo_calcolato]";
    input.id = "prezzo_calcolato_line_item";
    form.appendChild(input);
  }
  return input;
}

// ✅ Funzione di aggiornamento
function aggiornaPrezzoPersonalizzato() {
  const larghezza = getBssNumber("po_number_field926202");
  const altezza = getBssNumber("po_number_field926203");

  if (larghezza === null || altezza === null) {
    console.log("⏳ Larghezza o altezza non ancora disponibili");
    return;
  }

  const materialeInput = document.querySelector('[name="po_materiale"]');
  const spessoreInput = document.querySelector('[name="po_spessore"]');

  const materiale =
    materialeInput?.value?.trim().toLowerCase() ||
    window.customFallbacks?.materiale;
  const spessore = parseFloat(
    spessoreInput?.value || window.customFallbacks?.spessore
  );

  if (!materiale || isNaN(spessore)) {
    console.warn("⚠️ Materiale o spessore non validi");
    return;
  }

  const prezzoBase = 0.01;
  const prezzo = calcolaPrezzoPersonalizzato({
    larghezza_mm: larghezza,
    altezza_mm: altezza,
    materiale,
    spessore,
    prezzoBase,
  });

  if (prezzo !== null) {
    // ✅ Mostra il prezzo calcolato nel nodo visivo
    forzaPrezzoVisivo(prezzo); // 👈 chiamata GIUSTA e completa

    // ✅ Inserisce la line item property nel form
    const propertyInput = ensureLineItemPropertyInput();
    if (propertyInput) {
      propertyInput.value = `${prezzo.toFixed(2)} €`;
    }

    console.log(`💰 Prezzo mostrato: ${prezzo.toFixed(2)} €`);
  }
}

// ✅ Inizializzatore con polling
function initCalcoloPrezzoPersonalizzato() {
  let tentativi = 0;
  const maxTentativi = 20;
  const polling = setInterval(() => {
    const ok1 = document.getElementById("po_number_field926202"); // Sostituisci
    const ok2 = document.getElementById("po_number_field926203"); // Sostituisci
    if (ok1 && ok2) {
      clearInterval(polling);
      console.log("✅ Input trovati nel DOM");

      aggiornaPrezzoPersonalizzato();

      // Eventi input e change
      ok1.addEventListener("input", aggiornaPrezzoPersonalizzato);
      ok2.addEventListener("input", aggiornaPrezzoPersonalizzato);
      document
        .querySelector('[name="po_materiale"]')
        ?.addEventListener("change", aggiornaPrezzoPersonalizzato);
      document
        .querySelector('[name="po_spessore"]')
        ?.addEventListener("change", aggiornaPrezzoPersonalizzato);
    } else {
      tentativi++;
      if (tentativi > maxTentativi) {
        clearInterval(polling);
        console.warn("❌ Timeout: input numerici non trovati");
      }
    }
  }, 200);
}

function forzaPrezzoVisivo(prezzo) {
  const target = document.querySelector(".current-price.theme-money");
  if (!target) return;

  const formatted = `${prezzo.toFixed(2)} €`;
  target.textContent = formatted;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList" || mutation.type === "characterData") {
        if (target.textContent !== formatted) {
          target.textContent = formatted;
          console.log("🔁 Prezzo forzato a video via observer:", formatted);
        }
      }
    });
  });

  observer.observe(target, {
    characterData: true,
    childList: true,
    subtree: true,
  });

  // Disattiva l’osservatore dopo 10s (regolabile)
  setTimeout(() => observer.disconnect(), 10000);
}

window.initCalcoloPrezzoPersonalizzato = initCalcoloPrezzoPersonalizzato;

/* --- SCRIPT PER CALCOLO COSTI - FINE --- */

/* --- INIZIO Traduzioni --- */
const inputElement = document.querySelector(
  "input.btn.btn-default.btn-block.button"
);
if (inputElement) {
  inputElement.value = "Conferma il tuo design";
}
/* --- FINE Traduzioni --- */

/* --- INIZIO - SCRIPT PER CODICE FISCALE POPUP DATI FATTURA --- */
(function () {
  // Attende la comparsa del popup
  function waitFor(el, timeout = 10000) {
    return new Promise((res, rej) => {
      const n = document.querySelector(el);
      if (n) return res(n);
      const obs = new MutationObserver(() => {
        const n2 = document.querySelector(el);
        if (n2) {
          obs.disconnect();
          res(n2);
        }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(() => {
        obs.disconnect();
        rej(new Error("timeout"));
      }, timeout);
    });
  }

  const messages = {
    valueMissing: "Questo campo è obbligatorio.",
    typeMismatch: "Inserisci un valore corretto.",
    patternMismatch: "Formato non valido.",
    tooShort: "Il valore è troppo corto.",
    tooLong: "Il valore è troppo lungo.",
    rangeUnderflow: "Il valore è troppo basso.",
    rangeOverflow: "Il valore è troppo alto.",
    stepMismatch: "Valore non consentito.",
    badInput: "Inserisci un valore valido.",
  };

  waitFor("#invoice-popup-modal-embed")
    .then((root) => {
      // Delegato: forza maiuscolo + messaggi mentre si digita
      root.addEventListener("input", (e) => {
        const el = e.target;
        if (
          !(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement)
        )
          return;

        // Caso specifico Codice Fiscale
        if (el.id === "codiceFiscale") {
          el.value = el.value.toUpperCase();
          el.setAttribute(
            "title",
            "Scrivi il codice fiscale in MAIUSCOLO (16 caratteri)"
          );
          el.setCustomValidity("");
          if (el.value && !/^[A-Z0-9]{16}$/.test(el.value)) {
            el.setCustomValidity("Scrivi il codice fiscale in MAIUSCOLO.");
          }
          return;
        }

        // Generico
        el.setCustomValidity("");
        const v = el.validity;
        if (!v.valid) {
          for (const key in messages) {
            if (v[key]) {
              el.setCustomValidity(messages[key]);
              break;
            }
          }
        }
      });

      // Intercetta qualsiasi "invalid" nel popup e sostituisce il messaggio
      root.addEventListener(
        "invalid",
        (e) => {
          const el = e.target;
          if (
            !(
              el instanceof HTMLInputElement ||
              el instanceof HTMLTextAreaElement
            )
          )
            return;
          if (el.id === "codiceFiscale") {
            el.setCustomValidity(
              "Scrivi il codice fiscale in MAIUSCOLO (16 caratteri alfanumerici)."
            );
          } else {
            el.setCustomValidity("");
            const v = el.validity;
            if (!v.valid) {
              for (const key in messages) {
                if (v[key]) {
                  el.setCustomValidity(messages[key]);
                  break;
                }
              }
            }
          }
          // mostra subito il tooltip del browser col nostro testo
          if (el.reportValidity) el.reportValidity();
        },
        true
      ); // <-- capture = true per prendere l'evento nativo

      // Hook sul submit del form del popup
      const form = root.querySelector("form");
      if (form) {
        form.addEventListener("submit", (e) => {
          const inputs = form.querySelectorAll("input, textarea, select");
          inputs.forEach((el) => {
            if (el.id !== "codiceFiscale") {
              el.setCustomValidity("");
              const v = el.validity;
              if (!v.valid) {
                for (const key in messages) {
                  if (v[key]) {
                    el.setCustomValidity(messages[key]);
                    break;
                  }
                }
              }
            }
          });
          if (!form.checkValidity()) {
            e.preventDefault();
            const firstInvalid = form.querySelector(":invalid");
            if (firstInvalid && firstInvalid.reportValidity)
              firstInvalid.reportValidity();
          }
        });
      }
    })
    .catch(() => {
      /* popup non apparso entro timeout, ignora */
    });
})();
/* --- FINE - SCRIPT PER CODICE FISCALE POPUP DATI FATTURA --- */

/* --- INIZIO - RIPOSIZIONA POP-UP MODAL BSS COME BADGE INFO --- */
(function () {
  if (window.__bssPopupInfoManagerLoaded) return;
  window.__bssPopupInfoManagerLoaded = true;

  const SOURCE_BUTTON_SELECTOR = '.po-option--popup__button';
  const SOURCE_STACK_SELECTOR = '.po-stack';
  const TARGET_LABEL_SELECTOR = '.po-label-container .po-label > span';
  const RELOCATED_CLASS = 'bss-po-popup-stack--relocated';
  const PROXY_CLASS = 'bss-po-popup-info-trigger';
  const SOURCE_ID_ATTRIBUTE = 'data-bss-popup-source-id';
  let generatedSourceId = 0;

  function ensureSourceId(sourceStack) {
    if (sourceStack.id) return sourceStack.id;

    generatedSourceId += 1;
    sourceStack.id = 'bss-po-popup-source-' + generatedSourceId;
    return sourceStack.id;
  }

  function findFollowingOptionLabel(sourceStack) {
    let sibling = sourceStack.nextElementSibling;

    while (sibling) {
      if (sibling.matches(SOURCE_STACK_SELECTOR)) {
        const label = sibling.querySelector(TARGET_LABEL_SELECTOR);
        if (label) return label;
      }

      sibling = sibling.nextElementSibling;
    }

    return null;
  }

  function isSourceHidden(sourceStack) {
    return sourceStack.hidden ||
      sourceStack.style.display === 'none' ||
      sourceStack.getAttribute('aria-hidden') === 'true';
  }

  function findProxyForSource(sourceId) {
    return Array.from(document.querySelectorAll('.' + PROXY_CLASS)).find(function (proxy) {
      return proxy.getAttribute(SOURCE_ID_ATTRIBUTE) === sourceId;
    }) || null;
  }

  function getSourceButton(proxy) {
    const sourceId = proxy.getAttribute(SOURCE_ID_ATTRIBUTE);
    const sourceStack = sourceId ? document.getElementById(sourceId) : null;
    return sourceStack ? sourceStack.querySelector(SOURCE_BUTTON_SELECTOR) : null;
  }

  function syncPopupInfoBadges() {
    const activeSourceIds = new Set();

    document.querySelectorAll(SOURCE_BUTTON_SELECTOR).forEach(function (sourceButton) {
      const sourceStack = sourceButton.closest(SOURCE_STACK_SELECTOR);
      if (!sourceStack) return;

      const targetLabel = findFollowingOptionLabel(sourceStack);
      if (!targetLabel) {
        sourceStack.classList.remove(RELOCATED_CLASS);
        return;
      }

      const sourceId = ensureSourceId(sourceStack);
      const accessibleLabel = sourceButton.textContent.trim() || 'Apri informazioni';
      let proxy = findProxyForSource(sourceId);

      activeSourceIds.add(sourceId);
      sourceStack.classList.add(RELOCATED_CLASS);

      if (!proxy) {
        proxy = document.createElement('button');
        proxy.type = 'button';
        proxy.className = PROXY_CLASS;
        proxy.textContent = 'info';
        proxy.setAttribute(SOURCE_ID_ATTRIBUTE, sourceId);
      }

      if (proxy.parentElement !== targetLabel) targetLabel.appendChild(proxy);
      if (proxy.getAttribute('aria-label') !== accessibleLabel) proxy.setAttribute('aria-label', accessibleLabel);
      if (proxy.title !== accessibleLabel) proxy.title = accessibleLabel;

      const shouldBeHidden = isSourceHidden(sourceStack);
      if (proxy.hidden !== shouldBeHidden) proxy.hidden = shouldBeHidden;
    });

    document.querySelectorAll('.' + PROXY_CLASS).forEach(function (proxy) {
      const sourceId = proxy.getAttribute(SOURCE_ID_ATTRIBUTE);
      if (!sourceId || !activeSourceIds.has(sourceId)) proxy.remove();
    });

    document.querySelectorAll('.' + RELOCATED_CLASS).forEach(function (sourceStack) {
      if (!activeSourceIds.has(sourceStack.id)) sourceStack.classList.remove(RELOCATED_CLASS);
    });
  }

  function initBssPopupInfoManager() {
    let syncScheduled = false;

    function scheduleSync() {
      if (syncScheduled) return;

      syncScheduled = true;
      window.requestAnimationFrame(function () {
        syncScheduled = false;
        syncPopupInfoBadges();
      });
    }

    document.addEventListener('click', function (event) {
      const proxy = event.target.closest('.' + PROXY_CLASS);
      if (!proxy) return;

      const sourceButton = getSourceButton(proxy);
      if (!sourceButton) return;

      event.preventDefault();
      event.stopPropagation();
      sourceButton.click();
    }, true);

    syncPopupInfoBadges();

    const observer = new MutationObserver(scheduleSync);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBssPopupInfoManager);
  } else {
    initBssPopupInfoManager();
  }
})();
/* --- FINE - RIPOSIZIONA POP-UP MODAL BSS COME BADGE INFO --- */

/* --- INIZIO - BSS ICON MANAGER CENTRALIZZATO --- */
(function () {
  if (window.__bssIconManagerLoaded) return;
  window.__bssIconManagerLoaded = true;

  const BSS_ICON_CONFIG = {
    /* Icone "Ambiente di installazione" ed esposizione */
    recolor: [
      'po_stack991750',
      'po_stack991751',
      'po_stack991752',
      'po_stack1017860',
      'po_stack1394732',
      'po_stack1394729',
      'po_stack1394731',
      'po_stack1398786',
      'po_stack1398782',
      'po_stack1398785',
      'po_stack1429339',
      'po_stack1429336',
      'po_stack1429338'
    ],

    /* Timbro a secco */
    resize: [
      'po_stack1017860'
    ],
    grid4: [
      'po_stack1017860'
    ],
    maskFull: [
      'po_stack1017860'
    ]
  };

  const DEFAULT_MASK_ZOOM = 0.85;

  function getUrlFromCssValue(value) {
    if (!value || value === 'none') return null;

    const match = /url\((?:"|')?([^"')]+)(?:"|')?\)/.exec(value);
    return match ? match[1] : null;
  }

  function addClassToConfiguredStacks(stackIds, className) {
    stackIds.forEach(function (id) {
      const stack = document.getElementById(id);
      if (stack) stack.classList.add(className);
    });
  }

  function applyMaskSizing(el, scale) {
    const pct = Math.max(0.01, Math.min(2, scale)) * 100;

    el.style.webkitMaskSize = pct + '%';
    el.style.maskSize = pct + '%';

    el.style.webkitMaskPosition = 'center center';
    el.style.maskPosition = 'center center';

    el.style.webkitMaskRepeat = 'no-repeat';
    el.style.maskRepeat = 'no-repeat';
  }

  function normalizeIcon(el, options) {
    if (el.classList.contains('bss-icon-normalized')) return;

    const computed = window.getComputedStyle(el);

    const maskUrl =
      getUrlFromCssValue(el.style.webkitMaskImage) ||
      getUrlFromCssValue(el.style.maskImage) ||
      getUrlFromCssValue(computed.getPropertyValue('-webkit-mask-image')) ||
      getUrlFromCssValue(computed.getPropertyValue('mask-image'));

    const bgUrl =
      getUrlFromCssValue(el.style.backgroundImage) ||
      getUrlFromCssValue(computed.getPropertyValue('background-image'));

    const url = maskUrl || bgUrl;
    if (!url) return;

    const hasMask = !!maskUrl || el.classList.contains('po-masked');

    if (!hasMask) {
      el.style.backgroundImage = 'none';
      el.style.webkitMaskImage = 'url("' + url + '")';
      el.style.maskImage = 'url("' + url + '")';
    }

    el.classList.add('po-masked', 'bss-icon-normalized');

    /*
      Lasciamo il colore al CSS.
      Questo evita che eventuali inline style di BSS blocchino la ricolorazione.
    */
    el.style.backgroundColor = '';

    applyMaskSizing(el, options.zoom || DEFAULT_MASK_ZOOM);
  }

  function normalizeStackIcons(stackId) {
    const stack = document.getElementById(stackId);
    if (!stack) return;

    const forceFullMask = BSS_ICON_CONFIG.maskFull.includes(stackId);

    stack.querySelectorAll('.po-option__image-value').forEach(function (el) {
      normalizeIcon(el, {
        zoom: forceFullMask ? 1 : DEFAULT_MASK_ZOOM
      });
    });
  }

  function applyBssIconManager() {
    addClassToConfiguredStacks(BSS_ICON_CONFIG.recolor, 'bss-icon-recolor');
    addClassToConfiguredStacks(BSS_ICON_CONFIG.resize, 'bss-icon-resize');
    addClassToConfiguredStacks(BSS_ICON_CONFIG.grid4, 'bss-icon-grid4');
    addClassToConfiguredStacks(BSS_ICON_CONFIG.maskFull, 'bss-icon-mask-full');

    BSS_ICON_CONFIG.recolor.forEach(normalizeStackIcons);
  }

  function initBssIconManager() {
    let applyScheduled = false;

    function scheduleBssIconManager() {
      if (applyScheduled) return;

      applyScheduled = true;

      window.requestAnimationFrame(function () {
        applyScheduled = false;
        applyBssIconManager();
      });
    }

    applyBssIconManager();

    const observer = new MutationObserver(function () {
      scheduleBssIconManager();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBssIconManager);
  } else {
    initBssIconManager();
  }
})();
/* --- FINE - BSS ICON MANAGER CENTRALIZZATO --- */

/* --- SCRIPT PER DISATTIVAZIONE CONTROLLI LETTORE MULTIMEDIALE --- */
document.addEventListener('DOMContentLoaded', () => {
  const apply = v => { v.controls = false; v.removeAttribute('controls'); };
  document.querySelectorAll('video').forEach(apply);

  new MutationObserver(muts => {
    for (const m of muts) {
      if (m.type === 'attributes' && m.attributeName === 'controls' && m.target.tagName === 'VIDEO') apply(m.target);
      if (m.type === 'childList') m.addedNodes.forEach(n => {
        if (n.tagName === 'VIDEO') apply(n);
        else if (n.querySelectorAll) n.querySelectorAll('video').forEach(apply);
      });
    }
  }).observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['controls']});
});

/* --- SCRIPT PER SPOSTARE IL WIDGER JUDGE.ME --- */
document.addEventListener('DOMContentLoaded', initRating);
document.addEventListener('shopify:section:load', initRating);

function initRating() {
  const section = document.querySelector('[data-section-type="main-product"]');
  const anchor  = section?.querySelector('#dr-rating-anchor') || section?.querySelector('.price-container');
  if (!section || !anchor) return;

  const move = () => {
    const w = section.querySelector('.jdgm-preview-badge, [data-dr="rating-widget"]');
    if (w && w.parentNode !== anchor) anchor.appendChild(w);
  };

  move();
  new MutationObserver(move).observe(section, { childList: true, subtree: true });
}

/* --- SCRIPT PER ATTIVARE LA LIGHTBOX DEL TEMA ANCHE PER I PRODOTTI PITCHPRINT --- */
(function(){
  const SEC = document.querySelector('[data-section-type="main-product"]');
  if (!SEC) return;

  function normalize(){
    const pp = SEC.querySelector('a#placeholder.fancybox_.zoom.colorbox.cboxElement');
    const gal = SEC.querySelector('.gallery');
    if (!pp || !gal) return;

    pp.classList.add('show-gallery','focus-inset');
    pp.removeAttribute('id'); pp.removeAttribute('rel'); pp.removeAttribute('target');
    pp.setAttribute('data-pswp-open','');
    if (!gal.contains(pp)) { gal.innerHTML = ''; gal.append(pp); }
  }

  new MutationObserver(normalize).observe(SEC, {childList:true, subtree:true});
  normalize();
})();

/* --- SCRIPT PER ATTIVARE LA LIGHTBOX DEL TEMA ANCHE SULLE IMMAGINI FAQ --- */
(function () {
  function getImageSource(img, fallback) {
    if (!img) return fallback;
    return img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || img.getAttribute('data-msrc') || fallback;
  }

  function buildThumb(item) {
    const img = item.img;
    const src = getImageSource(img, item.zoomUrl);
    const alt = img ? img.getAttribute('alt') || '' : '';

    return $('<div>', { class: 'inline-image' })
      .attr('style', '--ar-padding: 100%; --content-fit: contain;')
      .append(
        $('<div>', { class: 'inline-image__pad' }).append(
          $('<img>', { class: 'inline-image__image loaded', src: src, alt: alt })
        )
      );
  }

  function collectFaqImages(faqItem) {
    const items = [];

    faqItem.querySelectorAll('.faq-media a.show-gallery[href]').forEach(function (link) {
      items.push({
        img: link.querySelector('img'),
        zoomUrl: link.getAttribute('href'),
        sourceElement: link
      });
    });

    faqItem.querySelectorAll('.cc-accordion-item__content.rte img').forEach(function (img) {
      if (img.closest('.faq-media a.show-gallery[href]')) return;

      const zoomUrl = getImageSource(img, img.getAttribute('src'));
      if (!zoomUrl) return;

      items.push({
        img: img,
        zoomUrl: zoomUrl,
        sourceElement: img
      });
    });

    return items;
  }

  document.addEventListener('click', function (evt) {
    const link = evt.target.closest('.collapsible-faqs .faq-media a.show-gallery[href]');
    const clickedImg = evt.target.closest('.collapsible-faqs .cc-accordion-item__content.rte img');

    if (!link && (!clickedImg || clickedImg.closest('a[href]'))) return;
    if (!window.theme || typeof theme.buildGalleryViewer !== 'function') return;

    evt.preventDefault();

    const currentTarget = link || clickedImg;
    const currentImage = link ? link.getAttribute('href') : getImageSource(clickedImg, clickedImg.getAttribute('src'));
    const faqItem = currentTarget.closest('.cc-accordion-item') || currentTarget.closest('.faq-media') || currentTarget.closest('.collapsible-faqs');
    const items = collectFaqImages(faqItem);
    const images = items.map(function (item) {
      return {
        thumbTag: buildThumb(item),
        zoomUrl: item.zoomUrl
      };
    });

    if (!images.length) return;

    theme.buildGalleryViewer({
      images: images,
      currentImage: currentImage,
      prev: theme.icons ? theme.icons.chevronLeft : '&lsaquo;',
      next: theme.icons ? theme.icons.chevronRight : '&rsaquo;',
      close: theme.icons ? theme.icons.close : '&times;'
    });
  });
})();

/* --- SCRIPT PER ATTIVARE LA LIGHTBOX DEL TEMA ANCHE SULLA PAGINA FILE GRAFICI --- */
(function () {
  const targetHandle = 'file-grafici-e-controllo-stampa';
  const currentPath = window.location.pathname.replace(/\/$/, '');

  if (!currentPath.endsWith('/' + targetHandle) && currentPath !== '/' + targetHandle) return;

  function isImageUrl(url) {
    if (!url) return false;
    return /\.(jpe?g|png|gif|webp|avif|svg)(\?|#|$)/i.test(url);
  }

  function getLargestSrcsetUrl(srcset) {
    if (!srcset) return '';

    return srcset.split(',')
      .map(function (entry) {
        const parts = entry.trim().split(/\s+/);
        const descriptor = parts[1] || '';
        const width = descriptor.endsWith('w') ? parseInt(descriptor, 10) : 0;

        return {
          url: parts[0] || '',
          width: Number.isNaN(width) ? 0 : width
        };
      })
      .filter(function (item) {
        return item.url;
      })
      .sort(function (a, b) {
        return b.width - a.width;
      })[0]?.url || '';
  }

  function getImageSource(img, fallback) {
    if (!img) return fallback;

    return getLargestSrcsetUrl(img.getAttribute('srcset')) ||
      img.currentSrc ||
      img.getAttribute('src') ||
      img.getAttribute('data-src') ||
      img.getAttribute('data-msrc') ||
      fallback;
  }

  function getImageLink(img) {
    const link = img.closest('a[href]');
    if (!link) return null;

    const href = link.getAttribute('href');
    return isImageUrl(href) ? link : null;
  }

  function buildThumb(item) {
    const src = getImageSource(item.img, item.zoomUrl);
    const alt = item.img ? item.img.getAttribute('alt') || '' : '';

    return $('<div>', { class: 'inline-image' })
      .attr('style', '--ar-padding: 100%; --content-fit: contain;')
      .append(
        $('<div>', { class: 'inline-image__pad' }).append(
          $('<img>', { class: 'inline-image__image loaded', src: src, alt: alt })
        )
      );
  }

  function collectPageImages(container) {
    const items = [];
    const seen = new Set();

    container.querySelectorAll('img').forEach(function (img) {
      const imageLink = getImageLink(img);

      if (img.closest('a[href]') && !imageLink) return;

      const zoomUrl = imageLink ? imageLink.getAttribute('href') : getImageSource(img, img.getAttribute('src'));
      if (!zoomUrl || seen.has(zoomUrl)) return;

      seen.add(zoomUrl);
      items.push({
        img: img,
        zoomUrl: zoomUrl
      });

      img.classList.add('page-lightbox-image');
      if (imageLink) {
        imageLink.classList.add('page-lightbox-link');
      }
    });

    return items;
  }

  function initPageLightbox() {
    const pageContent = document.querySelector('.template-page .rte');
    if (!pageContent || !window.theme || typeof theme.buildGalleryViewer !== 'function') return;

    collectPageImages(pageContent);

    pageContent.addEventListener('click', function (evt) {
      const clickedImg = evt.target.closest('img');
      if (!clickedImg || !pageContent.contains(clickedImg)) return;

      const imageLink = getImageLink(clickedImg);
      if (clickedImg.closest('a[href]') && !imageLink) return;

      evt.preventDefault();

      const items = collectPageImages(pageContent);
      const currentImage = imageLink ? imageLink.getAttribute('href') : getImageSource(clickedImg, clickedImg.getAttribute('src'));
      const images = items.map(function (item) {
        return {
          thumbTag: buildThumb(item),
          zoomUrl: item.zoomUrl
        };
      });

      if (!images.length) return;

      theme.buildGalleryViewer({
        images: images,
        currentImage: currentImage,
        prev: theme.icons ? theme.icons.chevronLeft : '&lsaquo;',
        next: theme.icons ? theme.icons.chevronRight : '&rsaquo;',
        close: theme.icons ? theme.icons.close : '&times;'
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageLightbox, { once: true });
  } else {
    initPageLightbox();
  }
})();

/* --- SCRIPT CHE LEGGE I TAG DEI PRODOTTI E LI INVIA ALL'IFRAME PITCHPRINT --- */
// INVIA TAG PRODOTTO A PITCHPRINT - INIZIO
(function () {
  function getProductTags() {
    const dataEl = document.querySelector('#bss-po-store-data');
    if (!dataEl) return [];

    try {
      const data = JSON.parse(dataEl.textContent);
      return data?.product?.tags || [];
    } catch (e) {
      console.warn('[PP Tags] JSON prodotto non leggibile', e);
      return [];
    }
  }

  function sendProductTagsToPitchPrint() {
    const iframe = document.querySelector('iframe[src*="pitchprint.io"]');
    if (!iframe || !iframe.contentWindow) return;

    const tags = getProductTags();

    iframe.contentWindow.postMessage({
      type: 'PP_PRODUCT_TAGS',
      tags
    }, 'https://pitchprint.io');
  }

  window.addEventListener('load', () => {
    setTimeout(sendProductTagsToPitchPrint, 1000);
    setTimeout(sendProductTagsToPitchPrint, 3000);
    setTimeout(sendProductTagsToPitchPrint, 6000);
  });
})();
// INVIA TAG PRODOTTO A PITCHPRINT - FINE

/* ---- NASCONDE SELETTORE VARIANTI e SMART SIZES DOPO PERSONALIZZAZIONE GRAFICA - INIZIO --- */
(function () {
  const OPTION0_SELECTOR = '#Option0';
  const PITCHPRINT_INPUT_SELECTOR = '#_pitchprint';
  const MESSAGE_CLASS = 'pp-smart-size-locked-message';
  const IS_CATALOG_FLOW =
    new URLSearchParams(window.location.search).get('pp_catalog_flow') === '1';

  function isVisible(element) {
    if (!element || element.hidden) return false;

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function hasPitchPrintDesign() {
    const input = document.querySelector(PITCHPRINT_INPUT_SELECTOR);
    const clearButton = document.querySelector('#pp_clear_design_btn');

    return !!(
      (input && input.value && input.value.trim()) ||
      isVisible(clearButton)
    );
  }

  function getVariantPicker() {
    const option0 = document.querySelector(OPTION0_SELECTOR);
    const productForm = option0?.closest('.product-form');
    return productForm ? productForm.querySelector('variant-picker') : null;
  }

  function getSizeGroup() {
    const picker = getVariantPicker();
    return picker ? picker.querySelector('.option-selector[data-index="1"]') : null;
  }

  function getVariantGroups() {
    const picker = getVariantPicker();
    const sizeGroup = getSizeGroup();
    if (!picker || !sizeGroup) return [];

    const groups = Array.from(picker.querySelectorAll('.option-selector[data-index]')).filter(function (group) {
      return group.closest('variant-picker') === picker;
    });

    return groups.length ? groups : [sizeGroup];
  }

  function getMessagePlacement() {
    const warning = document.querySelector('.product-form .product-warning');
    if (warning) {
      return {
        anchor: warning,
        position: 'afterend'
      };
    }

    const shortDescription = document.querySelector('.product-form .product-short-description');
    if (shortDescription) {
      return {
        anchor: shortDescription,
        position: 'afterend'
      };
    }

    const groups = getVariantGroups();
    return groups.length
      ? {
          anchor: groups[0],
          position: 'beforebegin'
        }
      : null;
  }

  function createLockedMessage(placement) {
    let message = document.querySelector('.' + MESSAGE_CLASS);

    if (!message) {
      message = document.createElement('div');
      message.className = MESSAGE_CLASS;

      const icon = document.createElement('span');
      icon.className = MESSAGE_CLASS + '__icon';
      icon.textContent = 'i';

      const text = document.createElement('span');
      text.textContent = `Configurazione applicata: la misura e la variante dell’articolo sono già state selezionate.
      Per modificarle, clicca prima su “Ricomincia”: la personalizzazione attuale verrà rimossa e potrai crearne una nuova.`;
      text.style.whiteSpace = 'pre-line';

      message.appendChild(icon);
      message.appendChild(text);
    }

    placement.anchor.insertAdjacentElement(placement.position, message);
  }

  function hideVariantSelectors() {
    const groups = getVariantGroups();
    const placement = getMessagePlacement();

    if (placement) {
      createLockedMessage(placement);
    }

    groups.forEach(function (group) {
      group.style.setProperty('display', 'none', 'important');
    });
  }

  function showVariantSelectors() {
    getVariantGroups().forEach(function (group) {
      group.style.removeProperty('display');
    });

    const message = document.querySelector('.' + MESSAGE_CLASS);

    if (message) {
      message.remove();
    }
  }

  function updateSmartSizeLock() {
    if (IS_CATALOG_FLOW) {
      showVariantSelectors();
      return;
    }

    if (hasPitchPrintDesign()) {
      hideVariantSelectors();
    } else {
      showVariantSelectors();
    }
  }

  function init() {
    updateSmartSizeLock();

    setInterval(updateSmartSizeLock, 500);

    document.addEventListener('click', function (event) {
      if (event.target && event.target.id === 'pp_clear_design_btn') {
        setTimeout(updateSmartSizeLock, 100);
        setTimeout(updateSmartSizeLock, 500);
        setTimeout(updateSmartSizeLock, 1000);
        setTimeout(updateSmartSizeLock, 2000);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ---- NASCONDE SELETTORE VARIANTI e SMART SIZES DOPO PERSONALIZZAZIONE GRAFICA - FINE --- */

/* ---- SINCRONIZZA SELECT STABILI PITCHPRINT DOPO RENDER VARIANTI - INIZIO --- */
(function () {
  if (window.__ppStableSelectSyncInstalled) return;
  window.__ppStableSelectSyncInstalled = true;

  function syncCompatibilitySelect(source, value) {
    if (!source || !value) return;

    const picker = source.closest('variant-picker');
    const group = source.closest('[data-index]');
    if (!picker || !group) return;

    const index = parseInt(group.dataset.index, 10) - 1;
    if (Number.isNaN(index)) return;

    const compatSelects = picker.closest('.product-form')?.querySelector('[data-pitchprint-variant-selects]');
    const select = compatSelects?.querySelector('#Option' + index);
    if (!select) return;

    if (select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function syncSelectedOptions() {
    document.querySelectorAll('variant-picker .option-selector[data-index]').forEach(function (group) {
      const selected =
        group.querySelector('input.js-option[type="radio"]:checked') ||
        group.querySelector('.custom-select__option.js-option[aria-selected="true"]');

      if (!selected) return;

      syncCompatibilitySelect(
        selected,
        selected.value || selected.dataset.value || ''
      );
    });
  }

  function sendCurrentOptionsToPitchPrint() {
    syncSelectedOptions();

    const compatSelects = document.querySelector('[data-pitchprint-variant-selects]');
    if (!compatSelects) return false;

    compatSelects.querySelectorAll('select[id^="Option"]').forEach(function (select) {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });

    return true;
  }

  window.ppSyncCurrentVariantToPitchPrint = sendCurrentOptionsToPitchPrint;

  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!input || !input.matches('variant-picker input.js-option[type="radio"]')) return;

    syncCompatibilitySelect(input, input.value);
  }, true);

  document.addEventListener('click', function (event) {
    const customOption = event.target.closest('variant-picker .custom-select__option.js-option');

    if (customOption) {
      syncCompatibilitySelect(customOption, customOption.dataset.value || '');
    }
  }, true);

  document.addEventListener('on:variant:change', syncSelectedOptions);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSelectedOptions);
  } else {
    syncSelectedOptions();
  }
})();
/* ---- SINCRONIZZA SELECT STABILI PITCHPRINT DOPO RENDER VARIANTI - FINE --- */

/* ---- PULSANTE VARIANTE SPECIALE CON LINK - INIZIO --- */
(function () {
  if (window.__variantLinkNavigationInstalled) return;
  window.__variantLinkNavigationInstalled = true;

  function getVariantLink(event) {
    const target = event.target;
    return target && typeof target.closest === 'function'
      ? target.closest('.opt-label--redirect[data-variant-link-url]')
      : null;
  }

  function navigateToVariantLink(link) {
    const url = link?.dataset.variantLinkUrl;
    if (url) window.location.assign(url);
  }

  document.addEventListener('click', function (event) {
    const link = getVariantLink(event);
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();
    navigateToVariantLink(link);
  }, true);

  document.addEventListener('keydown', function (event) {
    const link = getVariantLink(event);
    if (!link || (event.key !== 'Enter' && event.key !== ' ')) return;

    event.preventDefault();
    event.stopPropagation();
    navigateToVariantLink(link);
  }, true);
})();
/* ---- PULSANTE VARIANTE SPECIALE CON LINK - FINE --- */

/* ---- COPIA LINK FILE UPLOAD PITCHPRINT NELL'ORDINE SHOPIFY - INIZIO --- */
(function () {
  if (window.__ppBssPropertiesHookInstalled) return;
  window.__ppBssPropertiesHookInstalled = true;

  const originalCustomAttributeWhenAddToCart = window.bssFixSupportCustomAttributeWhenAddToCart;
  const originalCustomAttribute = window.bssFixSupportCustomAttribute;
  const PITCHPRINT_DOWNLOAD_NAME = 'properties[_pprint-pdf-download]';
  const PRIVATE_PREVIEW_PROPERTY = '_pitchprint_preview';
  const PRIVATE_DOWNLOAD_PROPERTY = '_pitchprint_pdf';
  const PRIVATE_PITCHPRINT_PROPERTIES = ['_pitchprint', PRIVATE_PREVIEW_PROPERTY, PRIVATE_DOWNLOAD_PROPERTY];
  const LEGACY_PUBLIC_PITCHPRINT_PROPERTIES = ['Preview', 'Anteprima file PitchPrint', 'File caricato'];

  function isPrivatePitchPrintProperty(key) {
    return PRIVATE_PITCHPRINT_PROPERTIES.includes(key);
  }

  function isLegacyPublicPitchPrintProperty(key) {
    return LEGACY_PUBLIC_PITCHPRINT_PROPERTIES.includes(key);
  }

  function removePropertyAliases(properties, key) {
    if (!properties || !key) return;
    delete properties[key];
    delete properties[' ' + key];
  }

  function getPitchPrintDownloadUrl() {
    const field = document.querySelector(
      'input[name="' + PITCHPRINT_DOWNLOAD_NAME + '"]:not([data-pp-bss-sync-field]), ' +
      'textarea[name="' + PITCHPRINT_DOWNLOAD_NAME + '"]:not([data-pp-bss-sync-field]), ' +
      'select[name="' + PITCHPRINT_DOWNLOAD_NAME + '"]:not([data-pp-bss-sync-field])'
    );

    return field && field.value ? field.value.trim() : '';
  }

  function parsePitchPrintProject(projectValue) {
    if (!projectValue) return null;

    if (typeof projectValue === 'object') {
      return projectValue;
    }

    try {
      return JSON.parse(decodeURIComponent(projectValue));
    } catch (error) {
      try {
        return JSON.parse(projectValue);
      } catch (plainJsonError) {
        return null;
      }
    }
  }

  function getPitchPrintProjectId() {
    const input =
      document.querySelector('input[name="properties[_pitchprint]"]:not([data-pp-bss-sync-field])') ||
      document.querySelector('input[name*="_pitchprint"]:not([data-pp-bss-sync-field])');

    return input && input.value ? input.value.trim() : '';
  }

  function getStoredPitchPrintProject(projectId) {
    let projects = null;

    try {
      projects = window.localStorage && window.localStorage.getItem('pprint-projects');
    } catch (error) {
      return null;
    }

    if (!projects) return null;

    try {
      projects = JSON.parse(projects);
    } catch (error) {
      return null;
    }

    return parsePitchPrintProject(projects[projectId]);
  }

  function getPitchPrintPreviewUrl(projectId) {
    if (!projectId) return '';

    const project = getStoredPitchPrintProject(projectId);

    if (project) {
      if (project.preview) return project.preview;
      if (project.previews && project.previews.length) return project.previews[0];
    }

    return 'https://s3-eu-west-1.amazonaws.com/pitchprint.io/previews/' + projectId + '_1.jpg';
  }

  function addPitchPrintProperties(chosenOptions, chosenOptionsWithoutPriceAddOns) {
    const projectId = getPitchPrintProjectId();
    const previewUrl = getPitchPrintPreviewUrl(projectId);
    const downloadUrl = getPitchPrintDownloadUrl();

    if (!projectId && !previewUrl && !downloadUrl) {
      return;
    }

    if (projectId) {
      chosenOptions.set('_pitchprint', projectId);
    }

    if (previewUrl) {
      chosenOptions.set(PRIVATE_PREVIEW_PROPERTY, previewUrl);
    }

    if (downloadUrl) {
      chosenOptions.set(PRIVATE_DOWNLOAD_PROPERTY, downloadUrl);
    }

    // La seconda mappa BSS alimenta la riga tecnica/duplicata del checkout:
    // PitchPrint deve restare solo sulla riga principale del prodotto.
    if (chosenOptionsWithoutPriceAddOns && typeof chosenOptionsWithoutPriceAddOns.delete === 'function') {
      PRIVATE_PITCHPRINT_PROPERTIES.concat(LEGACY_PUBLIC_PITCHPRINT_PROPERTIES).forEach(function (key) {
        chosenOptionsWithoutPriceAddOns.delete(key);
      });
    }
  }

  window.bssFixSupportCustomAttributeWhenAddToCart = function (BSS_PO, chosenOptions, chosenOptionsWithoutPriceAddOns) {
    let result = {
      chosenOptions,
      chosenOptionsWithoutPriceAddOns
    };

    if (typeof originalCustomAttributeWhenAddToCart === 'function') {
      result = originalCustomAttributeWhenAddToCart(BSS_PO, chosenOptions, chosenOptionsWithoutPriceAddOns) || result;
    }

    addPitchPrintProperties(result.chosenOptions, result.chosenOptionsWithoutPriceAddOns);

    return result;
  };

  window.bssFixSupportCustomAttribute = function (BSS_PO, key, value, properties) {
    if (typeof originalCustomAttribute === 'function') {
      originalCustomAttribute(BSS_PO, key, value, properties);

      if (isLegacyPublicPitchPrintProperty(key)) {
        removePropertyAliases(properties, key);
        return;
      }

      if (!isPrivatePitchPrintProperty(key)) {
        return;
      }
    }

    if (isPrivatePitchPrintProperty(key)) {
      properties[key] = value;
      delete properties[' ' + key];
      return;
    }

    if (isLegacyPublicPitchPrintProperty(key)) {
      removePropertyAliases(properties, key);
      return;
    }

    properties[' ' + key] = value;
  };
})();

(function () {
  const FORM_SELECTOR = [
    'form.product-purchase-form.js-product-form-stable',
    'form.shopify-product-form[action*="/cart/add"]',
    '.shopify-app-block form[action*="/cart/add"]'
  ].join(',');

  const SOURCE_PDF_NAME = 'properties[_pprint-pdf-download]';
  const SOURCE_PNG_NAME = 'properties[_pprint-png-download]';
  const PUBLIC_PREVIEW_NAME = 'properties[Anteprima file PitchPrint]';
  const PRIVATE_PREVIEW_NAME = 'properties[_pitchprint_preview]';
  const LEGACY_BSS_PREVIEW_NAME = 'properties[Preview]';
  const PRIVATE_PDF_NAME = 'properties[_pitchprint_pdf]';
  const LEGACY_PUBLIC_PDF_NAME = 'properties[File caricato]';
  const PITCHPRINT_PROJECT_NAME = 'properties[_pitchprint]';
  const SYNC_FIELD_ATTR = 'data-pp-bss-sync-field';

  function getProductForm() {
    return document.querySelector(FORM_SELECTOR);
  }

  function getProductForms() {
    return Array.from(document.querySelectorAll(FORM_SELECTOR));
  }

  function findFieldAnywhere(name) {
    return document.querySelector(
      'input[name="' + name + '"]:not([' + SYNC_FIELD_ATTR + ']), ' +
      'textarea[name="' + name + '"]:not([' + SYNC_FIELD_ATTR + ']), ' +
      'select[name="' + name + '"]:not([' + SYNC_FIELD_ATTR + '])'
    );
  }

  function ensureHiddenFieldInForm(form, name) {
    let field = form.querySelector(
      'input[name="' + name + '"], textarea[name="' + name + '"], select[name="' + name + '"]'
    );

    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }

    return field;
  }

  function parsePitchPrintProject(projectValue) {
    if (!projectValue) return null;

    if (typeof projectValue === 'object') {
      return projectValue;
    }

    try {
      return JSON.parse(decodeURIComponent(projectValue));
    } catch (error) {
      try {
        return JSON.parse(projectValue);
      } catch (plainJsonError) {
        return null;
      }
    }
  }

  function getStoredPitchPrintProject(projectId) {
    let projects = null;

    try {
      projects = window.localStorage && window.localStorage.getItem('pprint-projects');
    } catch (error) {
      return null;
    }

    if (!projects) return null;

    try {
      projects = JSON.parse(projects);
    } catch (error) {
      return null;
    }

    return parsePitchPrintProject(projects[projectId]);
  }

  function getPitchPrintPreviewUrl(projectId) {
    if (!projectId) return '';

    const project = getStoredPitchPrintProject(projectId);

    if (project) {
      if (project.preview) return project.preview;
      if (project.previews && project.previews.length) return project.previews[0];
    }

    return 'https://s3-eu-west-1.amazonaws.com/pitchprint.io/previews/' + projectId + '_1.jpg';
  }

  function copyFieldValue(form, name, value, sourceField) {
    if (!form || !value) return;

    const field = ensureHiddenFieldInForm(form, name);
    field.value = value;

    if (field !== sourceField) {
      field.setAttribute(SYNC_FIELD_ATTR, 'true');
    }
  }

  function removeFieldFromForm(form, name) {
    form.querySelectorAll(
      'input[name="' + name + '"], textarea[name="' + name + '"], select[name="' + name + '"]'
    ).forEach(function (field) {
      field.remove();
    });
  }

  function disableFieldInForm(form, name) {
    form.querySelectorAll(
      'input[name="' + name + '"], textarea[name="' + name + '"], select[name="' + name + '"]'
    ).forEach(function (field) {
      field.disabled = true;
    });
  }

  function removeSyncedFieldFromForm(form, name) {
    form.querySelectorAll(
      'input[name="' + name + '"][' + SYNC_FIELD_ATTR + '], ' +
      'textarea[name="' + name + '"][' + SYNC_FIELD_ATTR + '], ' +
      'select[name="' + name + '"][' + SYNC_FIELD_ATTR + ']'
    ).forEach(function (field) {
      field.remove();
    });
  }

  function syncPitchPrintUploadFields() {
    const forms = getProductForms();
    if (!forms.length) return;

    if (window.ProductAddonSelectorSync?.sync instanceof Function) {
      window.ProductAddonSelectorSync.sync();
    }

    const sourcePdf = findFieldAnywhere(SOURCE_PDF_NAME);
    const pitchPrintInput = findFieldAnywhere(PITCHPRINT_PROJECT_NAME);
    const pitchPrintProjectId = pitchPrintInput && pitchPrintInput.value && pitchPrintInput.value.trim();
    const pitchPrintPreviewUrl = getPitchPrintPreviewUrl(pitchPrintProjectId);

    forms.forEach(function (form) {
      if (sourcePdf && sourcePdf.value) {
        copyFieldValue(form, PRIVATE_PDF_NAME, sourcePdf.value, sourcePdf);
      }

      removeFieldFromForm(form, LEGACY_PUBLIC_PDF_NAME);
      removeSyncedFieldFromForm(form, PITCHPRINT_PROJECT_NAME);

      if (pitchPrintPreviewUrl) {
        copyFieldValue(form, PRIVATE_PREVIEW_NAME, pitchPrintPreviewUrl);
      } else {
        removeSyncedFieldFromForm(form, PRIVATE_PREVIEW_NAME);
      }

      // PitchPrint aggiorna questi campi anche durante "Ricomincia": devono restare nel DOM.
      disableFieldInForm(form, SOURCE_PDF_NAME);
      disableFieldInForm(form, SOURCE_PNG_NAME);
      removeFieldFromForm(form, PUBLIC_PREVIEW_NAME);
      removeFieldFromForm(form, LEGACY_BSS_PREVIEW_NAME);
    });
  }

  function initPitchPrintUploadFieldSync() {
    if (!getProductForm()) return;

    setInterval(syncPitchPrintUploadFields, 300);

    document.addEventListener('click', function (event) {
      const addToCartButton = event.target.closest('button[type="submit"]');
      const form = addToCartButton && addToCartButton.closest('form[action*="/cart/add"]');

      if (form && form.matches(FORM_SELECTOR)) {
        syncPitchPrintUploadFields();
      }
    }, true);

    document.addEventListener('submit', function (event) {
      if (event.target && event.target.matches(FORM_SELECTOR)) {
        syncPitchPrintUploadFields();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPitchPrintUploadFieldSync);
  } else {
    initPitchPrintUploadFieldSync();
  }
})();
/* ---- COPIA LINK FILE UPLOAD PITCHPRINT NELL'ORDINE SHOPIFY - FINE --- */

/* ---- AUTOPOSIZIONAMENTO SUL PULSANTE DEL CARRELLO DOPO CONFERMA GRAFICA PITCHPRINT - INIZIO --- */
(function () {
  if (window.__ppFocusCartInstalled) return;
  window.__ppFocusCartInstalled = true;

  const DEBUG = false;
  const IS_CATALOG_FLOW =
    new URLSearchParams(window.location.search).get('pp_catalog_flow') === '1';

  const PP_TRIGGER_SELECTOR = [
    '#pp_customize_design_btn',
    '#pp_edit_btn',
    '#pp_upload_btn'
  ].join(',');

  const CART_BUTTON_SELECTOR = [
    '.quantity-submit-row__submit button[type="submit"]',
    'button[name="add"]',
    'button[type="submit"][name="add"]',
    '.product-form__submit',
    '[data-add-to-cart]'
  ].join(',');

  let watching = false;
  let initialPitchPrintValue = null;
  let watchStartedAt = 0;
  let watchTimer = null;

  function log() {
    if (!DEBUG) return;
    console.log('[PP focus cart]', ...arguments);
  }

  function getPitchPrintInput() {
    return (
      document.querySelector('input[name="properties[_pitchprint]"]:not([data-pp-bss-sync-field])') ||
      document.querySelector('input[name*="_pitchprint"]:not([data-pp-bss-sync-field])') ||
      document.querySelector('input[name*="pitchprint"]:not([data-pp-bss-sync-field])')
    );
  }

  function getPitchPrintValue() {
    const input = getPitchPrintInput();
    return input ? String(input.value || '').trim() : '';
  }

  function getCartButton() {
    return document.querySelector(CART_BUTTON_SELECTOR);
  }

  function getCatalogVariantTarget() {
    const group = document.querySelector(
      'variant-picker .option-selector[data-index]'
    );

    if (!group) {
      return null;
    }

    return {
      scrollTarget: group,
      focusTarget: group.querySelector(
        'input:not([type="hidden"]), button, [tabindex]:not([tabindex="-1"])'
      )
    };
  }

  function scrollToCartButton() {
    const cartButton = getCartButton();
    const catalogTarget = IS_CATALOG_FLOW ? getCatalogVariantTarget() : null;
    const scrollTarget = catalogTarget?.scrollTarget || cartButton;
    const focusTarget = catalogTarget?.focusTarget || cartButton;

    if (!scrollTarget) {
      log('Destinazione scorrimento non trovata');
      return false;
    }

    const y =
      scrollTarget.getBoundingClientRect().top +
      window.pageYOffset -
      window.innerHeight * 0.45;

    window.scrollTo({
      top: Math.max(0, y),
      behavior: 'smooth'
    });

    setTimeout(function () {
      if (!focusTarget) return;

      try {
        focusTarget.focus({ preventScroll: true });
      } catch (e) {
        focusTarget.focus();
      }
    }, 500);

    log(
      IS_CATALOG_FLOW
        ? 'Scroll eseguito verso le varianti'
        : 'Scroll eseguito verso il carrello'
    );
    return true;
  }

  function stopWatching() {
    watching = false;
    window.__ppFocusCartWatching = false;

    if (watchTimer) {
      clearTimeout(watchTimer);
      watchTimer = null;
    }
  }

  function startWatching() {
    stopWatching();

    window.__ppFocusCartWatching = true;

    watching = true;
    watchStartedAt = Date.now();
    initialPitchPrintValue = getPitchPrintValue();

    checkPitchPrintReturn();
  }

  function checkPitchPrintReturn() {
    if (!watching) return;

    const currentValue = getPitchPrintValue();
    const elapsed = Date.now() - watchStartedAt;

    const hasNewPitchPrintValue =
      currentValue &&
      currentValue !== initialPitchPrintValue;

    log('Controllo ritorno', {
      elapsed,
      initialPitchPrintValue,
      currentValue,
      hasNewPitchPrintValue
    });

    if (hasNewPitchPrintValue) {
      setTimeout(function () {
        scrollToCartButton();
      }, 600);

      stopWatching();
      return;
    }

    /*
      Timeout di sicurezza:
      se PitchPrint non cambia il valore _pitchprint,
      dopo il ritorno può comunque servire un tentativo.
      Non lo facciamo subito, per evitare scroll mentre il compositore è ancora aperto.
    */
    if (elapsed > 3000 && currentValue) {
      setTimeout(function () {
        scrollToCartButton();
      }, 600);

      stopWatching();
      return;
    }

    if (elapsed > 120000) {
      log('Timeout: ritorno PitchPrint non rilevato');
      stopWatching();
      return;
    }

    watchTimer = setTimeout(checkPitchPrintReturn, 500);
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      const trigger = event.target.closest(PP_TRIGGER_SELECTOR);

      if (!trigger) return;

      startWatching();
    },
    true
  );

  /*
    Comando manuale di test:
    puoi scrivere in console:
    ppFocusCartNow()
  */
  window.ppFocusCartNow = scrollToCartButton;
  window.ppStartFocusCartWatching = startWatching;
})();
/* ---- AUTOPOSIZIONAMENTO SUL PULSANTE DEL CARRELLO DOPO CONFERMA GRAFICA PITCHPRINT - FINE --- */

(function () {
  const params = new URLSearchParams(window.location.search);
  const designId = params.get('pp_design');
  const shouldOpen = params.get('pp_autostart') === '1';
  const isSupportedDesignId = /^[a-z0-9_-]{8,128}$/i.test(designId || '');

  if (!shouldOpen || !isSupportedDesignId) {
    return;
  }

  let opened = false;
  const deadline = Date.now() + 20000;

  function clearAutostartParams() {
    const url = new URL(window.location.href);
    url.searchParams.delete('pp_design');
    url.searchParams.delete('pp_autostart');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  }

  function openPitchPrintDesign() {
    if (opened) {
      return true;
    }

    const client = window.ppclient;
    const designSelect =
      document.getElementById('pp_design_select') ||
      (client && client._ui && client._ui.designSelect);
    const designStack = client && client.vars && client.vars.designStack;
    const categoryReady =
      client &&
      client.vars &&
      (!client.vars.isCategory || client.vars.catModule === true);

    if (
      !client ||
      !client.act ||
      !client.act.frameValidated ||
      !categoryReady ||
      typeof client.showApp !== 'function'
    ) {
      return false;
    }

    if (typeof window.ppSyncCurrentVariantToPitchPrint === 'function') {
      window.ppSyncCurrentVariantToPitchPrint();
    }

    opened = true;

    if (designSelect && designStack && designStack[designId]) {
      designSelect.value = designId;
      designSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    clearAutostartParams();

    if (typeof window.ppStartFocusCartWatching === 'function') {
      window.ppStartFocusCartWatching();
    }

    window.setTimeout(function () {
      client.showApp({ designId: designId });
    }, 150);

    return true;
  }

  function waitForPitchPrint() {
    if (openPitchPrintDesign() || Date.now() >= deadline) {
      return;
    }

    window.setTimeout(waitForPitchPrint, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForPitchPrint, { once: true });
  } else {
    waitForPitchPrint();
  }
})();
